/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SpInviteIndexRouteImport } from './routes/sp-invite/index'
import { Route as SpHomeIndexRouteImport } from './routes/sp-home/index'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as FormBuilderFormBuilderLayoutRouteImport } from './routes/form-builder/_formBuilderLayout'
import { Route as WorkOrdersAddWorkOrderIndexRouteImport } from './routes/work-orders/add-work-order/index'
import { Route as UserManagementAddUserIndexRouteImport } from './routes/user-management/add-user/index'
import { Route as SpW9TokenIndexRouteImport } from './routes/sp-w9/$token/index'
import { Route as SpVisitFormTokenIndexRouteImport } from './routes/sp-visit-form/$token/index'
import { Route as SpPaymentTokenIndexRouteImport } from './routes/sp-payment/$token/index'
import { Route as RolesPermissionsAssignPermissionsIndexRouteImport } from './routes/roles-permissions/assign-permissions/index'
import { Route as FormBuilderEditorIndexRouteImport } from './routes/form-builder/editor/index'
import { Route as EntitiesCreateEntityIndexRouteImport } from './routes/entities/create-entity/index'
import { Route as UnauthenticatedResetPasswordIndexRouteImport } from './routes/_unauthenticated/reset-password/index'
import { Route as UnauthenticatedResetLinkExpiryIndexRouteImport } from './routes/_unauthenticated/reset-link-expiry/index'
import { Route as UnauthenticatedLoginIndexRouteImport } from './routes/_unauthenticated/login/index'
import { Route as UnauthenticatedForgotPasswordIndexRouteImport } from './routes/_unauthenticated/forgot-password/index'
import { Route as AuthenticatedWorkOrdersIndexRouteImport } from './routes/_authenticated/work-orders/index'
import { Route as AuthenticatedUserManagementIndexRouteImport } from './routes/_authenticated/user-management/index'
import { Route as AuthenticatedSpCalendarIndexRouteImport } from './routes/_authenticated/sp-calendar/index'
import { Route as AuthenticatedShortLinksIndexRouteImport } from './routes/_authenticated/short-links/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedServiceProvidersIndexRouteImport } from './routes/_authenticated/service-providers/index'
import { Route as AuthenticatedRolesPermissionsIndexRouteImport } from './routes/_authenticated/roles-permissions/index'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedProposalsIndexRouteImport } from './routes/_authenticated/proposals/index'
import { Route as AuthenticatedProcurementIndexRouteImport } from './routes/_authenticated/procurement/index'
import { Route as AuthenticatedMyTasksIndexRouteImport } from './routes/_authenticated/my-tasks/index'
import { Route as AuthenticatedLocationsIndexRouteImport } from './routes/_authenticated/locations/index'
import { Route as AuthenticatedLiveMapIndexRouteImport } from './routes/_authenticated/live-map/index'
import { Route as AuthenticatedFormManagerIndexRouteImport } from './routes/_authenticated/form-manager/index'
import { Route as AuthenticatedFormBuilderIndexRouteImport } from './routes/_authenticated/form-builder/index'
import { Route as AuthenticatedFmIntegrationsIndexRouteImport } from './routes/_authenticated/fm-integrations/index'
import { Route as AuthenticatedFilesIndexRouteImport } from './routes/_authenticated/files/index'
import { Route as AuthenticatedEntitiesIndexRouteImport } from './routes/_authenticated/entities/index'
import { Route as AuthenticatedEmailAiIndexRouteImport } from './routes/_authenticated/email-ai/index'
import { Route as AuthenticatedDispatchQueueIndexRouteImport } from './routes/_authenticated/dispatch-queue/index'
import { Route as AuthenticatedCloseOutIndexRouteImport } from './routes/_authenticated/close-out/index'
import { Route as AuthenticatedClientsIndexRouteImport } from './routes/_authenticated/clients/index'
import { Route as AuthenticatedCheckInOutIndexRouteImport } from './routes/_authenticated/check-in-out/index'
import { Route as AuthenticatedChatIndexRouteImport } from './routes/_authenticated/chat/index'
import { Route as AuthenticatedAssetsIndexRouteImport } from './routes/_authenticated/assets/index'
import { Route as AuthenticatedAllFilesIndexRouteImport } from './routes/_authenticated/all-files/index'
import { Route as AuthenticatedAccountsReceivableIndexRouteImport } from './routes/_authenticated/accounts-receivable/index'
import { Route as AuthenticatedAccountsPayableIndexRouteImport } from './routes/_authenticated/accounts-payable/index'
import { Route as UserManagementAddUserUserIdRouteImport } from './routes/user-management/add-user/$userId'
import { Route as SpInviteReviewReviewLayoutRouteImport } from './routes/sp-invite/review/_reviewLayout'
import { Route as ServiceProvidersOnboardingOnboardingLayoutRouteImport } from './routes/service-providers/onboarding/_onboardingLayout'
import { Route as EntitiesCreateEntitySuccessRouteImport } from './routes/entities/create-entity/success'
import { Route as EntitiesCreateEntityAddUsersRouteImport } from './routes/entities/create-entity/add-users'
import { Route as ClientsAddNewClientAddNewClientLayoutRouteImport } from './routes/clients/add-new-client/_addNewClientLayout'
import { Route as ClientsIdEditClientCoverageRouteImport } from './routes/clients/$id/edit-client-coverage'
import { Route as UnauthenticatedSsoCallbackRouteImport } from './routes/_unauthenticated/sso/callback'
import { Route as AuthenticatedUserManagementUserIdRouteImport } from './routes/_authenticated/user-management/$userId'
import { Route as AuthenticatedShortLinksLinkIdRouteImport } from './routes/_authenticated/short-links/$linkId'
import { Route as AuthenticatedServiceProvidersIdRouteImport } from './routes/_authenticated/service-providers/$id'
import { Route as AuthenticatedRolesPermissionsCompareRouteImport } from './routes/_authenticated/roles-permissions/compare'
import { Route as AuthenticatedRolesPermissionsRoleIdRouteImport } from './routes/_authenticated/roles-permissions/$roleId'
import { Route as AuthenticatedProposalsManageRouteImport } from './routes/_authenticated/proposals/manage'
import { Route as AuthenticatedProcurementStorageUnitsRouteImport } from './routes/_authenticated/procurement/storage-units'
import { Route as AuthenticatedProcurementReturnsRouteImport } from './routes/_authenticated/procurement/returns'
import { Route as AuthenticatedProcurementOverviewRouteImport } from './routes/_authenticated/procurement/overview'
import { Route as AuthenticatedProcurementNewRouteImport } from './routes/_authenticated/procurement/new'
import { Route as AuthenticatedProcurementCalendarRouteImport } from './routes/_authenticated/procurement/calendar'
import { Route as AuthenticatedProcurementAccountsRouteImport } from './routes/_authenticated/procurement/accounts'
import { Route as AuthenticatedProcurementRequestIdRouteImport } from './routes/_authenticated/procurement/$requestId'
import { Route as AuthenticatedLocationsIdRouteImport } from './routes/_authenticated/locations/$id'
import { Route as AuthenticatedLiveMapAlertsRouteImport } from './routes/_authenticated/live-map/alerts'
import { Route as AuthenticatedEntitiesEntityIdRouteImport } from './routes/_authenticated/entities/$entityId'
import { Route as AuthenticatedCloseOutWorkOrderIdRouteImport } from './routes/_authenticated/close-out/$workOrderId'
import { Route as AuthenticatedClientsIdRouteImport } from './routes/_authenticated/clients/$id'
import { Route as AuthenticatedAccountsPayableSpPaymentMethodsRouteImport } from './routes/_authenticated/accounts-payable/sp-payment-methods'
import { Route as AuthenticatedAccountsPayableManageRouteImport } from './routes/_authenticated/accounts-payable/manage'
import { Route as WorkOrdersWorkOrderIdEditWorkOrderIndexRouteImport } from './routes/work-orders/$workOrderId/edit-work-order/index'
import { Route as WorkOrdersWorkOrderIdCheckInIndexRouteImport } from './routes/work-orders/$workOrderId/checkIn/index'
import { Route as WorkOrdersWorkOrderIdAddVisitIndexRouteImport } from './routes/work-orders/$workOrderId/add-visit/index'
import { Route as WorkOrdersWorkOrderIdAcceptWorkOrderIndexRouteImport } from './routes/work-orders/$workOrderId/accept-work-order/index'
import { Route as SpInviteReviewAlignmentScheduledIndexRouteImport } from './routes/sp-invite/review/alignment-scheduled/index'
import { Route as FormBuilderFormBuilderLayoutTemplatesIndexRouteImport } from './routes/form-builder/_formBuilderLayout/templates/index'
import { Route as FormBuilderFormBuilderLayoutAssignmentsIndexRouteImport } from './routes/form-builder/_formBuilderLayout/assignments/index'
import { Route as AuthenticatedWorkOrdersWorkOrderIdIndexRouteImport } from './routes/_authenticated/work-orders/$workOrderId/index'
import { Route as AuthenticatedServiceProvidersW9RequestsIndexRouteImport } from './routes/_authenticated/service-providers/w9-requests/index'
import { Route as AuthenticatedServiceProvidersReactiveHireRequestsIndexRouteImport } from './routes/_authenticated/service-providers/reactive-hire-requests/index'
import { Route as AuthenticatedProcurementPricingIndexRouteImport } from './routes/_authenticated/procurement/pricing/index'
import { Route as AuthenticatedMobileWorkOrderIndexRouteImport } from './routes/_authenticated/mobile/work-order/index'
import { Route as AuthenticatedMobileScheduleIndexRouteImport } from './routes/_authenticated/mobile/schedule/index'
import { Route as AuthenticatedMobileChatIndexRouteImport } from './routes/_authenticated/mobile/chat/index'
import { Route as AuthenticatedClientsTeamAssignmentsIndexRouteImport } from './routes/_authenticated/clients/team-assignments/index'
import { Route as ServiceProvidersIdAlignmentAlignmentLayoutRouteImport } from './routes/service-providers/$id/alignment/_alignmentLayout'
import { Route as FormBuilderFormBuilderLayoutAssignmentsCategoryRouteImport } from './routes/form-builder/_formBuilderLayout/assignments/$category'
import { Route as AuthenticatedProcurementPricingPricingRequestIdRouteImport } from './routes/_authenticated/procurement/pricing/$pricingRequestId'
import { Route as AuthenticatedFilesSTokenRouteImport } from './routes/_authenticated/files/s/$token'
import { Route as WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRouteImport } from './routes/work-orders/$workOrderId/accept-work-order/work-order-filled/index'
import { Route as WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRouteImport } from './routes/work-orders/$workOrderId/accept-work-order/work-order-accepted/index'
import { Route as WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRouteImport } from './routes/work-orders/$workOrderId/$visitId/form-preview/index'
import { Route as WorkOrdersWorkOrderIdVisitIdEditIndexRouteImport } from './routes/work-orders/$workOrderId/$visitId/edit/index'
import { Route as WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRouteImport } from './routes/work-orders/$workOrderId/$visitId/assessment-details/index'
import { Route as SpInviteReviewReviewLayoutCompleteSubmissionIndexRouteImport } from './routes/sp-invite/review/_reviewLayout/complete-submission/index'
import { Route as ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRouteImport } from './routes/service-providers/onboarding/_onboardingLayout/complete-onboarding/index'
import { Route as ClientsAddNewClientAddNewClientLayoutStepIdIndexRouteImport } from './routes/clients/add-new-client/_addNewClientLayout/$stepId/index'
import { Route as ClientsIdEditRatesLaborFeeIndexRouteImport } from './routes/clients/$id/edit-rates/labor-fee/index'
import { Route as AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRouteImport } from './routes/_authenticated/work-orders/$workOrderId/$visitId/index'
import { Route as WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteImport } from './routes/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout'
import { Route as FormBuilderFormBuilderLayoutTemplatesIdEditRouteImport } from './routes/form-builder/_formBuilderLayout/templates/$id/edit'
import { Route as AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRouteImport } from './routes/_authenticated/work-orders/$workOrderId/$visitId/resolved-forms'
import { Route as WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRouteImport } from './routes/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/index'
import { Route as SpInviteReviewReviewLayoutProviderTypeStepIdIndexRouteImport } from './routes/sp-invite/review/_reviewLayout/$providerType/$stepId/index'
import { Route as ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRouteImport } from './routes/service-providers/onboarding/_onboardingLayout/$providerType/$stepId/index'
import { Route as ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRouteImport } from './routes/service-providers/$id/alignment/_alignmentLayout/$providerType/index'
import { Route as AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRouteImport } from './routes/_authenticated/work-orders/$workOrderId/proposal/create/index'
import { Route as AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRouteImport } from './routes/_authenticated/mobile/work-order/jobsite-assessment/$id/index'
import { Route as AuthenticatedMobileWorkOrderDetailsIdIndexRouteImport } from './routes/_authenticated/mobile/work-order/details/$id/index'
import { Route as AuthenticatedMobileWorkOrderCheckInIdIndexRouteImport } from './routes/_authenticated/mobile/work-order/check-in/$id/index'
import { Route as AuthenticatedMobileWorkOrderAcceptIdIndexRouteImport } from './routes/_authenticated/mobile/work-order/accept/$Id/index'
import { Route as WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRouteImport } from './routes/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/request-provider'
import { Route as ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRouteImport } from './routes/service-providers/$id/alignment/_alignmentLayout/$providerType/summary/index'
import { Route as ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRouteImport } from './routes/service-providers/$id/alignment/_alignmentLayout/$providerType/$stepId/index'

const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SpInviteIndexRoute = SpInviteIndexRouteImport.update({
  id: '/sp-invite/',
  path: '/sp-invite/',
  getParentRoute: () => rootRouteImport,
} as any)
const SpHomeIndexRoute = SpHomeIndexRouteImport.update({
  id: '/sp-home/',
  path: '/sp-home/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const FormBuilderFormBuilderLayoutRoute =
  FormBuilderFormBuilderLayoutRouteImport.update({
    id: '/form-builder/_formBuilderLayout',
    path: '/form-builder',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkOrdersAddWorkOrderIndexRoute =
  WorkOrdersAddWorkOrderIndexRouteImport.update({
    id: '/work-orders/add-work-order/',
    path: '/work-orders/add-work-order/',
    getParentRoute: () => rootRouteImport,
  } as any)
const UserManagementAddUserIndexRoute =
  UserManagementAddUserIndexRouteImport.update({
    id: '/user-management/add-user/',
    path: '/user-management/add-user/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SpW9TokenIndexRoute = SpW9TokenIndexRouteImport.update({
  id: '/sp-w9/$token/',
  path: '/sp-w9/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const SpVisitFormTokenIndexRoute = SpVisitFormTokenIndexRouteImport.update({
  id: '/sp-visit-form/$token/',
  path: '/sp-visit-form/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const SpPaymentTokenIndexRoute = SpPaymentTokenIndexRouteImport.update({
  id: '/sp-payment/$token/',
  path: '/sp-payment/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const RolesPermissionsAssignPermissionsIndexRoute =
  RolesPermissionsAssignPermissionsIndexRouteImport.update({
    id: '/roles-permissions/assign-permissions/',
    path: '/roles-permissions/assign-permissions/',
    getParentRoute: () => rootRouteImport,
  } as any)
const FormBuilderEditorIndexRoute = FormBuilderEditorIndexRouteImport.update({
  id: '/form-builder/editor/',
  path: '/form-builder/editor/',
  getParentRoute: () => rootRouteImport,
} as any)
const EntitiesCreateEntityIndexRoute =
  EntitiesCreateEntityIndexRouteImport.update({
    id: '/entities/create-entity/',
    path: '/entities/create-entity/',
    getParentRoute: () => rootRouteImport,
  } as any)
const UnauthenticatedResetPasswordIndexRoute =
  UnauthenticatedResetPasswordIndexRouteImport.update({
    id: '/reset-password/',
    path: '/reset-password/',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedResetLinkExpiryIndexRoute =
  UnauthenticatedResetLinkExpiryIndexRouteImport.update({
    id: '/reset-link-expiry/',
    path: '/reset-link-expiry/',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedLoginIndexRoute =
  UnauthenticatedLoginIndexRouteImport.update({
    id: '/login/',
    path: '/login/',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedForgotPasswordIndexRoute =
  UnauthenticatedForgotPasswordIndexRouteImport.update({
    id: '/forgot-password/',
    path: '/forgot-password/',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedWorkOrdersIndexRoute =
  AuthenticatedWorkOrdersIndexRouteImport.update({
    id: '/work-orders/',
    path: '/work-orders/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUserManagementIndexRoute =
  AuthenticatedUserManagementIndexRouteImport.update({
    id: '/user-management/',
    path: '/user-management/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSpCalendarIndexRoute =
  AuthenticatedSpCalendarIndexRouteImport.update({
    id: '/sp-calendar/',
    path: '/sp-calendar/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedShortLinksIndexRoute =
  AuthenticatedShortLinksIndexRouteImport.update({
    id: '/short-links/',
    path: '/short-links/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedServiceProvidersIndexRoute =
  AuthenticatedServiceProvidersIndexRouteImport.update({
    id: '/service-providers/',
    path: '/service-providers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesPermissionsIndexRoute =
  AuthenticatedRolesPermissionsIndexRouteImport.update({
    id: '/roles-permissions/',
    path: '/roles-permissions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProposalsIndexRoute =
  AuthenticatedProposalsIndexRouteImport.update({
    id: '/proposals/',
    path: '/proposals/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProcurementIndexRoute =
  AuthenticatedProcurementIndexRouteImport.update({
    id: '/procurement/',
    path: '/procurement/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyTasksIndexRoute =
  AuthenticatedMyTasksIndexRouteImport.update({
    id: '/my-tasks/',
    path: '/my-tasks/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationsIndexRoute =
  AuthenticatedLocationsIndexRouteImport.update({
    id: '/locations/',
    path: '/locations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLiveMapIndexRoute =
  AuthenticatedLiveMapIndexRouteImport.update({
    id: '/live-map/',
    path: '/live-map/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFormManagerIndexRoute =
  AuthenticatedFormManagerIndexRouteImport.update({
    id: '/form-manager/',
    path: '/form-manager/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFormBuilderIndexRoute =
  AuthenticatedFormBuilderIndexRouteImport.update({
    id: '/form-builder/',
    path: '/form-builder/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFmIntegrationsIndexRoute =
  AuthenticatedFmIntegrationsIndexRouteImport.update({
    id: '/fm-integrations/',
    path: '/fm-integrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFilesIndexRoute = AuthenticatedFilesIndexRouteImport.update({
  id: '/files/',
  path: '/files/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEntitiesIndexRoute =
  AuthenticatedEntitiesIndexRouteImport.update({
    id: '/entities/',
    path: '/entities/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmailAiIndexRoute =
  AuthenticatedEmailAiIndexRouteImport.update({
    id: '/email-ai/',
    path: '/email-ai/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDispatchQueueIndexRoute =
  AuthenticatedDispatchQueueIndexRouteImport.update({
    id: '/dispatch-queue/',
    path: '/dispatch-queue/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCloseOutIndexRoute =
  AuthenticatedCloseOutIndexRouteImport.update({
    id: '/close-out/',
    path: '/close-out/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsIndexRoute =
  AuthenticatedClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCheckInOutIndexRoute =
  AuthenticatedCheckInOutIndexRouteImport.update({
    id: '/check-in-out/',
    path: '/check-in-out/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatIndexRoute = AuthenticatedChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAssetsIndexRoute =
  AuthenticatedAssetsIndexRouteImport.update({
    id: '/assets/',
    path: '/assets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAllFilesIndexRoute =
  AuthenticatedAllFilesIndexRouteImport.update({
    id: '/all-files/',
    path: '/all-files/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountsReceivableIndexRoute =
  AuthenticatedAccountsReceivableIndexRouteImport.update({
    id: '/accounts-receivable/',
    path: '/accounts-receivable/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountsPayableIndexRoute =
  AuthenticatedAccountsPayableIndexRouteImport.update({
    id: '/accounts-payable/',
    path: '/accounts-payable/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const UserManagementAddUserUserIdRoute =
  UserManagementAddUserUserIdRouteImport.update({
    id: '/user-management/add-user/$userId',
    path: '/user-management/add-user/$userId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SpInviteReviewReviewLayoutRoute =
  SpInviteReviewReviewLayoutRouteImport.update({
    id: '/sp-invite/review/_reviewLayout',
    path: '/sp-invite/review',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServiceProvidersOnboardingOnboardingLayoutRoute =
  ServiceProvidersOnboardingOnboardingLayoutRouteImport.update({
    id: '/service-providers/onboarding/_onboardingLayout',
    path: '/service-providers/onboarding',
    getParentRoute: () => rootRouteImport,
  } as any)
const EntitiesCreateEntitySuccessRoute =
  EntitiesCreateEntitySuccessRouteImport.update({
    id: '/entities/create-entity/success',
    path: '/entities/create-entity/success',
    getParentRoute: () => rootRouteImport,
  } as any)
const EntitiesCreateEntityAddUsersRoute =
  EntitiesCreateEntityAddUsersRouteImport.update({
    id: '/entities/create-entity/add-users',
    path: '/entities/create-entity/add-users',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClientsAddNewClientAddNewClientLayoutRoute =
  ClientsAddNewClientAddNewClientLayoutRouteImport.update({
    id: '/clients/add-new-client/_addNewClientLayout',
    path: '/clients/add-new-client',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClientsIdEditClientCoverageRoute =
  ClientsIdEditClientCoverageRouteImport.update({
    id: '/clients/$id/edit-client-coverage',
    path: '/clients/$id/edit-client-coverage',
    getParentRoute: () => rootRouteImport,
  } as any)
const UnauthenticatedSsoCallbackRoute =
  UnauthenticatedSsoCallbackRouteImport.update({
    id: '/sso/callback',
    path: '/sso/callback',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedUserManagementUserIdRoute =
  AuthenticatedUserManagementUserIdRouteImport.update({
    id: '/user-management/$userId',
    path: '/user-management/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedShortLinksLinkIdRoute =
  AuthenticatedShortLinksLinkIdRouteImport.update({
    id: '/short-links/$linkId',
    path: '/short-links/$linkId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedServiceProvidersIdRoute =
  AuthenticatedServiceProvidersIdRouteImport.update({
    id: '/service-providers/$id',
    path: '/service-providers/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesPermissionsCompareRoute =
  AuthenticatedRolesPermissionsCompareRouteImport.update({
    id: '/roles-permissions/compare',
    path: '/roles-permissions/compare',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesPermissionsRoleIdRoute =
  AuthenticatedRolesPermissionsRoleIdRouteImport.update({
    id: '/roles-permissions/$roleId',
    path: '/roles-permissions/$roleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProposalsManageRoute =
  AuthenticatedProposalsManageRouteImport.update({
    id: '/proposals/manage',
    path: '/proposals/manage',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProcurementStorageUnitsRoute =
  AuthenticatedProcurementStorageUnitsRouteImport.update({
    id: '/procurement/storage-units',
    path: '/procurement/storage-units',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProcurementReturnsRoute =
  AuthenticatedProcurementReturnsRouteImport.update({
    id: '/procurement/returns',
    path: '/procurement/returns',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProcurementOverviewRoute =
  AuthenticatedProcurementOverviewRouteImport.update({
    id: '/procurement/overview',
    path: '/procurement/overview',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProcurementNewRoute =
  AuthenticatedProcurementNewRouteImport.update({
    id: '/procurement/new',
    path: '/procurement/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProcurementCalendarRoute =
  AuthenticatedProcurementCalendarRouteImport.update({
    id: '/procurement/calendar',
    path: '/procurement/calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProcurementAccountsRoute =
  AuthenticatedProcurementAccountsRouteImport.update({
    id: '/procurement/accounts',
    path: '/procurement/accounts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProcurementRequestIdRoute =
  AuthenticatedProcurementRequestIdRouteImport.update({
    id: '/procurement/$requestId',
    path: '/procurement/$requestId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationsIdRoute =
  AuthenticatedLocationsIdRouteImport.update({
    id: '/locations/$id',
    path: '/locations/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLiveMapAlertsRoute =
  AuthenticatedLiveMapAlertsRouteImport.update({
    id: '/live-map/alerts',
    path: '/live-map/alerts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEntitiesEntityIdRoute =
  AuthenticatedEntitiesEntityIdRouteImport.update({
    id: '/entities/$entityId',
    path: '/entities/$entityId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCloseOutWorkOrderIdRoute =
  AuthenticatedCloseOutWorkOrderIdRouteImport.update({
    id: '/close-out/$workOrderId',
    path: '/close-out/$workOrderId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsIdRoute = AuthenticatedClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountsPayableSpPaymentMethodsRoute =
  AuthenticatedAccountsPayableSpPaymentMethodsRouteImport.update({
    id: '/accounts-payable/sp-payment-methods',
    path: '/accounts-payable/sp-payment-methods',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountsPayableManageRoute =
  AuthenticatedAccountsPayableManageRouteImport.update({
    id: '/accounts-payable/manage',
    path: '/accounts-payable/manage',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const WorkOrdersWorkOrderIdEditWorkOrderIndexRoute =
  WorkOrdersWorkOrderIdEditWorkOrderIndexRouteImport.update({
    id: '/work-orders/$workOrderId/edit-work-order/',
    path: '/work-orders/$workOrderId/edit-work-order/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkOrdersWorkOrderIdCheckInIndexRoute =
  WorkOrdersWorkOrderIdCheckInIndexRouteImport.update({
    id: '/work-orders/$workOrderId/checkIn/',
    path: '/work-orders/$workOrderId/checkIn/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkOrdersWorkOrderIdAddVisitIndexRoute =
  WorkOrdersWorkOrderIdAddVisitIndexRouteImport.update({
    id: '/work-orders/$workOrderId/add-visit/',
    path: '/work-orders/$workOrderId/add-visit/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkOrdersWorkOrderIdAcceptWorkOrderIndexRoute =
  WorkOrdersWorkOrderIdAcceptWorkOrderIndexRouteImport.update({
    id: '/work-orders/$workOrderId/accept-work-order/',
    path: '/work-orders/$workOrderId/accept-work-order/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SpInviteReviewAlignmentScheduledIndexRoute =
  SpInviteReviewAlignmentScheduledIndexRouteImport.update({
    id: '/sp-invite/review/alignment-scheduled/',
    path: '/sp-invite/review/alignment-scheduled/',
    getParentRoute: () => rootRouteImport,
  } as any)
const FormBuilderFormBuilderLayoutTemplatesIndexRoute =
  FormBuilderFormBuilderLayoutTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => FormBuilderFormBuilderLayoutRoute,
  } as any)
const FormBuilderFormBuilderLayoutAssignmentsIndexRoute =
  FormBuilderFormBuilderLayoutAssignmentsIndexRouteImport.update({
    id: '/assignments/',
    path: '/assignments/',
    getParentRoute: () => FormBuilderFormBuilderLayoutRoute,
  } as any)
const AuthenticatedWorkOrdersWorkOrderIdIndexRoute =
  AuthenticatedWorkOrdersWorkOrderIdIndexRouteImport.update({
    id: '/work-orders/$workOrderId/',
    path: '/work-orders/$workOrderId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedServiceProvidersW9RequestsIndexRoute =
  AuthenticatedServiceProvidersW9RequestsIndexRouteImport.update({
    id: '/service-providers/w9-requests/',
    path: '/service-providers/w9-requests/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedServiceProvidersReactiveHireRequestsIndexRoute =
  AuthenticatedServiceProvidersReactiveHireRequestsIndexRouteImport.update({
    id: '/service-providers/reactive-hire-requests/',
    path: '/service-providers/reactive-hire-requests/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProcurementPricingIndexRoute =
  AuthenticatedProcurementPricingIndexRouteImport.update({
    id: '/procurement/pricing/',
    path: '/procurement/pricing/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMobileWorkOrderIndexRoute =
  AuthenticatedMobileWorkOrderIndexRouteImport.update({
    id: '/mobile/work-order/',
    path: '/mobile/work-order/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMobileScheduleIndexRoute =
  AuthenticatedMobileScheduleIndexRouteImport.update({
    id: '/mobile/schedule/',
    path: '/mobile/schedule/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMobileChatIndexRoute =
  AuthenticatedMobileChatIndexRouteImport.update({
    id: '/mobile/chat/',
    path: '/mobile/chat/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsTeamAssignmentsIndexRoute =
  AuthenticatedClientsTeamAssignmentsIndexRouteImport.update({
    id: '/clients/team-assignments/',
    path: '/clients/team-assignments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const ServiceProvidersIdAlignmentAlignmentLayoutRoute =
  ServiceProvidersIdAlignmentAlignmentLayoutRouteImport.update({
    id: '/service-providers/$id/alignment/_alignmentLayout',
    path: '/service-providers/$id/alignment',
    getParentRoute: () => rootRouteImport,
  } as any)
const FormBuilderFormBuilderLayoutAssignmentsCategoryRoute =
  FormBuilderFormBuilderLayoutAssignmentsCategoryRouteImport.update({
    id: '/assignments/$category',
    path: '/assignments/$category',
    getParentRoute: () => FormBuilderFormBuilderLayoutRoute,
  } as any)
const AuthenticatedProcurementPricingPricingRequestIdRoute =
  AuthenticatedProcurementPricingPricingRequestIdRouteImport.update({
    id: '/procurement/pricing/$pricingRequestId',
    path: '/procurement/pricing/$pricingRequestId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFilesSTokenRoute =
  AuthenticatedFilesSTokenRouteImport.update({
    id: '/files/s/$token',
    path: '/files/s/$token',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRoute =
  WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRouteImport.update({
    id: '/work-orders/$workOrderId/accept-work-order/work-order-filled/',
    path: '/work-orders/$workOrderId/accept-work-order/work-order-filled/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRoute =
  WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRouteImport.update({
    id: '/work-orders/$workOrderId/accept-work-order/work-order-accepted/',
    path: '/work-orders/$workOrderId/accept-work-order/work-order-accepted/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRoute =
  WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRouteImport.update({
    id: '/work-orders/$workOrderId/$visitId/form-preview/',
    path: '/work-orders/$workOrderId/$visitId/form-preview/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkOrdersWorkOrderIdVisitIdEditIndexRoute =
  WorkOrdersWorkOrderIdVisitIdEditIndexRouteImport.update({
    id: '/work-orders/$workOrderId/$visitId/edit/',
    path: '/work-orders/$workOrderId/$visitId/edit/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRoute =
  WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRouteImport.update({
    id: '/work-orders/$workOrderId/$visitId/assessment-details/',
    path: '/work-orders/$workOrderId/$visitId/assessment-details/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SpInviteReviewReviewLayoutCompleteSubmissionIndexRoute =
  SpInviteReviewReviewLayoutCompleteSubmissionIndexRouteImport.update({
    id: '/complete-submission/',
    path: '/complete-submission/',
    getParentRoute: () => SpInviteReviewReviewLayoutRoute,
  } as any)
const ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRoute =
  ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRouteImport.update(
    {
      id: '/complete-onboarding/',
      path: '/complete-onboarding/',
      getParentRoute: () => ServiceProvidersOnboardingOnboardingLayoutRoute,
    } as any,
  )
const ClientsAddNewClientAddNewClientLayoutStepIdIndexRoute =
  ClientsAddNewClientAddNewClientLayoutStepIdIndexRouteImport.update({
    id: '/$stepId/',
    path: '/$stepId/',
    getParentRoute: () => ClientsAddNewClientAddNewClientLayoutRoute,
  } as any)
const ClientsIdEditRatesLaborFeeIndexRoute =
  ClientsIdEditRatesLaborFeeIndexRouteImport.update({
    id: '/clients/$id/edit-rates/labor-fee/',
    path: '/clients/$id/edit-rates/labor-fee/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRoute =
  AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRouteImport.update({
    id: '/work-orders/$workOrderId/$visitId/',
    path: '/work-orders/$workOrderId/$visitId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRoute =
  WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteImport.update(
    {
      id: '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout',
      path: '/work-orders/$workOrderId/$visitId/assign-service-provider',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const FormBuilderFormBuilderLayoutTemplatesIdEditRoute =
  FormBuilderFormBuilderLayoutTemplatesIdEditRouteImport.update({
    id: '/templates/$id/edit',
    path: '/templates/$id/edit',
    getParentRoute: () => FormBuilderFormBuilderLayoutRoute,
  } as any)
const AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRoute =
  AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRouteImport.update({
    id: '/work-orders/$workOrderId/$visitId/resolved-forms',
    path: '/work-orders/$workOrderId/$visitId/resolved-forms',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRoute =
  WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRoute,
    } as any,
  )
const SpInviteReviewReviewLayoutProviderTypeStepIdIndexRoute =
  SpInviteReviewReviewLayoutProviderTypeStepIdIndexRouteImport.update({
    id: '/$providerType/$stepId/',
    path: '/$providerType/$stepId/',
    getParentRoute: () => SpInviteReviewReviewLayoutRoute,
  } as any)
const ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRoute =
  ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRouteImport.update(
    {
      id: '/$providerType/$stepId/',
      path: '/$providerType/$stepId/',
      getParentRoute: () => ServiceProvidersOnboardingOnboardingLayoutRoute,
    } as any,
  )
const ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRoute =
  ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRouteImport.update(
    {
      id: '/$providerType/',
      path: '/$providerType/',
      getParentRoute: () => ServiceProvidersIdAlignmentAlignmentLayoutRoute,
    } as any,
  )
const AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRoute =
  AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRouteImport.update({
    id: '/work-orders/$workOrderId/proposal/create/',
    path: '/work-orders/$workOrderId/proposal/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRoute =
  AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRouteImport.update({
    id: '/mobile/work-order/jobsite-assessment/$id/',
    path: '/mobile/work-order/jobsite-assessment/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMobileWorkOrderDetailsIdIndexRoute =
  AuthenticatedMobileWorkOrderDetailsIdIndexRouteImport.update({
    id: '/mobile/work-order/details/$id/',
    path: '/mobile/work-order/details/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMobileWorkOrderCheckInIdIndexRoute =
  AuthenticatedMobileWorkOrderCheckInIdIndexRouteImport.update({
    id: '/mobile/work-order/check-in/$id/',
    path: '/mobile/work-order/check-in/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMobileWorkOrderAcceptIdIndexRoute =
  AuthenticatedMobileWorkOrderAcceptIdIndexRouteImport.update({
    id: '/mobile/work-order/accept/$Id/',
    path: '/mobile/work-order/accept/$Id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRoute =
  WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRouteImport.update(
    {
      id: '/request-provider',
      path: '/request-provider',
      getParentRoute: () =>
        WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRoute,
    } as any,
  )
const ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRoute =
  ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRouteImport.update(
    {
      id: '/$providerType/summary/',
      path: '/$providerType/summary/',
      getParentRoute: () => ServiceProvidersIdAlignmentAlignmentLayoutRoute,
    } as any,
  )
const ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRoute =
  ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRouteImport.update(
    {
      id: '/$providerType/$stepId/',
      path: '/$providerType/$stepId/',
      getParentRoute: () => ServiceProvidersIdAlignmentAlignmentLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/form-builder': typeof FormBuilderFormBuilderLayoutRouteWithChildren
  '/sp-home/': typeof SpHomeIndexRoute
  '/sp-invite/': typeof SpInviteIndexRoute
  '/accounts-payable/manage': typeof AuthenticatedAccountsPayableManageRoute
  '/accounts-payable/sp-payment-methods': typeof AuthenticatedAccountsPayableSpPaymentMethodsRoute
  '/clients/$id': typeof AuthenticatedClientsIdRoute
  '/close-out/$workOrderId': typeof AuthenticatedCloseOutWorkOrderIdRoute
  '/entities/$entityId': typeof AuthenticatedEntitiesEntityIdRoute
  '/live-map/alerts': typeof AuthenticatedLiveMapAlertsRoute
  '/locations/$id': typeof AuthenticatedLocationsIdRoute
  '/procurement/$requestId': typeof AuthenticatedProcurementRequestIdRoute
  '/procurement/accounts': typeof AuthenticatedProcurementAccountsRoute
  '/procurement/calendar': typeof AuthenticatedProcurementCalendarRoute
  '/procurement/new': typeof AuthenticatedProcurementNewRoute
  '/procurement/overview': typeof AuthenticatedProcurementOverviewRoute
  '/procurement/returns': typeof AuthenticatedProcurementReturnsRoute
  '/procurement/storage-units': typeof AuthenticatedProcurementStorageUnitsRoute
  '/proposals/manage': typeof AuthenticatedProposalsManageRoute
  '/roles-permissions/$roleId': typeof AuthenticatedRolesPermissionsRoleIdRoute
  '/roles-permissions/compare': typeof AuthenticatedRolesPermissionsCompareRoute
  '/service-providers/$id': typeof AuthenticatedServiceProvidersIdRoute
  '/short-links/$linkId': typeof AuthenticatedShortLinksLinkIdRoute
  '/user-management/$userId': typeof AuthenticatedUserManagementUserIdRoute
  '/sso/callback': typeof UnauthenticatedSsoCallbackRoute
  '/clients/$id/edit-client-coverage': typeof ClientsIdEditClientCoverageRoute
  '/clients/add-new-client': typeof ClientsAddNewClientAddNewClientLayoutRouteWithChildren
  '/entities/create-entity/add-users': typeof EntitiesCreateEntityAddUsersRoute
  '/entities/create-entity/success': typeof EntitiesCreateEntitySuccessRoute
  '/service-providers/onboarding': typeof ServiceProvidersOnboardingOnboardingLayoutRouteWithChildren
  '/sp-invite/review': typeof SpInviteReviewReviewLayoutRouteWithChildren
  '/user-management/add-user/$userId': typeof UserManagementAddUserUserIdRoute
  '/accounts-payable/': typeof AuthenticatedAccountsPayableIndexRoute
  '/accounts-receivable/': typeof AuthenticatedAccountsReceivableIndexRoute
  '/all-files/': typeof AuthenticatedAllFilesIndexRoute
  '/assets/': typeof AuthenticatedAssetsIndexRoute
  '/chat/': typeof AuthenticatedChatIndexRoute
  '/check-in-out/': typeof AuthenticatedCheckInOutIndexRoute
  '/clients/': typeof AuthenticatedClientsIndexRoute
  '/close-out/': typeof AuthenticatedCloseOutIndexRoute
  '/dispatch-queue/': typeof AuthenticatedDispatchQueueIndexRoute
  '/email-ai/': typeof AuthenticatedEmailAiIndexRoute
  '/entities/': typeof AuthenticatedEntitiesIndexRoute
  '/files/': typeof AuthenticatedFilesIndexRoute
  '/fm-integrations/': typeof AuthenticatedFmIntegrationsIndexRoute
  '/form-builder/': typeof AuthenticatedFormBuilderIndexRoute
  '/form-manager/': typeof AuthenticatedFormManagerIndexRoute
  '/live-map/': typeof AuthenticatedLiveMapIndexRoute
  '/locations/': typeof AuthenticatedLocationsIndexRoute
  '/my-tasks/': typeof AuthenticatedMyTasksIndexRoute
  '/procurement/': typeof AuthenticatedProcurementIndexRoute
  '/proposals/': typeof AuthenticatedProposalsIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/roles-permissions/': typeof AuthenticatedRolesPermissionsIndexRoute
  '/service-providers/': typeof AuthenticatedServiceProvidersIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/short-links/': typeof AuthenticatedShortLinksIndexRoute
  '/sp-calendar/': typeof AuthenticatedSpCalendarIndexRoute
  '/user-management/': typeof AuthenticatedUserManagementIndexRoute
  '/work-orders/': typeof AuthenticatedWorkOrdersIndexRoute
  '/forgot-password/': typeof UnauthenticatedForgotPasswordIndexRoute
  '/login/': typeof UnauthenticatedLoginIndexRoute
  '/reset-link-expiry/': typeof UnauthenticatedResetLinkExpiryIndexRoute
  '/reset-password/': typeof UnauthenticatedResetPasswordIndexRoute
  '/entities/create-entity/': typeof EntitiesCreateEntityIndexRoute
  '/form-builder/editor/': typeof FormBuilderEditorIndexRoute
  '/roles-permissions/assign-permissions/': typeof RolesPermissionsAssignPermissionsIndexRoute
  '/sp-payment/$token/': typeof SpPaymentTokenIndexRoute
  '/sp-visit-form/$token/': typeof SpVisitFormTokenIndexRoute
  '/sp-w9/$token/': typeof SpW9TokenIndexRoute
  '/user-management/add-user/': typeof UserManagementAddUserIndexRoute
  '/work-orders/add-work-order/': typeof WorkOrdersAddWorkOrderIndexRoute
  '/files/s/$token': typeof AuthenticatedFilesSTokenRoute
  '/procurement/pricing/$pricingRequestId': typeof AuthenticatedProcurementPricingPricingRequestIdRoute
  '/form-builder/assignments/$category': typeof FormBuilderFormBuilderLayoutAssignmentsCategoryRoute
  '/service-providers/$id/alignment': typeof ServiceProvidersIdAlignmentAlignmentLayoutRouteWithChildren
  '/clients/team-assignments/': typeof AuthenticatedClientsTeamAssignmentsIndexRoute
  '/mobile/chat/': typeof AuthenticatedMobileChatIndexRoute
  '/mobile/schedule/': typeof AuthenticatedMobileScheduleIndexRoute
  '/mobile/work-order/': typeof AuthenticatedMobileWorkOrderIndexRoute
  '/procurement/pricing/': typeof AuthenticatedProcurementPricingIndexRoute
  '/service-providers/reactive-hire-requests/': typeof AuthenticatedServiceProvidersReactiveHireRequestsIndexRoute
  '/service-providers/w9-requests/': typeof AuthenticatedServiceProvidersW9RequestsIndexRoute
  '/work-orders/$workOrderId/': typeof AuthenticatedWorkOrdersWorkOrderIdIndexRoute
  '/form-builder/assignments/': typeof FormBuilderFormBuilderLayoutAssignmentsIndexRoute
  '/form-builder/templates/': typeof FormBuilderFormBuilderLayoutTemplatesIndexRoute
  '/sp-invite/review/alignment-scheduled/': typeof SpInviteReviewAlignmentScheduledIndexRoute
  '/work-orders/$workOrderId/accept-work-order/': typeof WorkOrdersWorkOrderIdAcceptWorkOrderIndexRoute
  '/work-orders/$workOrderId/add-visit/': typeof WorkOrdersWorkOrderIdAddVisitIndexRoute
  '/work-orders/$workOrderId/checkIn/': typeof WorkOrdersWorkOrderIdCheckInIndexRoute
  '/work-orders/$workOrderId/edit-work-order/': typeof WorkOrdersWorkOrderIdEditWorkOrderIndexRoute
  '/work-orders/$workOrderId/$visitId/resolved-forms': typeof AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRoute
  '/form-builder/templates/$id/edit': typeof FormBuilderFormBuilderLayoutTemplatesIdEditRoute
  '/work-orders/$workOrderId/$visitId/assign-service-provider': typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteWithChildren
  '/work-orders/$workOrderId/$visitId/': typeof AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRoute
  '/clients/$id/edit-rates/labor-fee/': typeof ClientsIdEditRatesLaborFeeIndexRoute
  '/clients/add-new-client/$stepId/': typeof ClientsAddNewClientAddNewClientLayoutStepIdIndexRoute
  '/service-providers/onboarding/complete-onboarding/': typeof ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRoute
  '/sp-invite/review/complete-submission/': typeof SpInviteReviewReviewLayoutCompleteSubmissionIndexRoute
  '/work-orders/$workOrderId/$visitId/assessment-details/': typeof WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRoute
  '/work-orders/$workOrderId/$visitId/edit/': typeof WorkOrdersWorkOrderIdVisitIdEditIndexRoute
  '/work-orders/$workOrderId/$visitId/form-preview/': typeof WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRoute
  '/work-orders/$workOrderId/accept-work-order/work-order-accepted/': typeof WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRoute
  '/work-orders/$workOrderId/accept-work-order/work-order-filled/': typeof WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRoute
  '/work-orders/$workOrderId/$visitId/assign-service-provider/request-provider': typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRoute
  '/mobile/work-order/accept/$Id/': typeof AuthenticatedMobileWorkOrderAcceptIdIndexRoute
  '/mobile/work-order/check-in/$id/': typeof AuthenticatedMobileWorkOrderCheckInIdIndexRoute
  '/mobile/work-order/details/$id/': typeof AuthenticatedMobileWorkOrderDetailsIdIndexRoute
  '/mobile/work-order/jobsite-assessment/$id/': typeof AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRoute
  '/work-orders/$workOrderId/proposal/create/': typeof AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRoute
  '/service-providers/$id/alignment/$providerType/': typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRoute
  '/service-providers/onboarding/$providerType/$stepId/': typeof ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRoute
  '/sp-invite/review/$providerType/$stepId/': typeof SpInviteReviewReviewLayoutProviderTypeStepIdIndexRoute
  '/work-orders/$workOrderId/$visitId/assign-service-provider/': typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRoute
  '/service-providers/$id/alignment/$providerType/$stepId/': typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRoute
  '/service-providers/$id/alignment/$providerType/summary/': typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/form-builder': typeof AuthenticatedFormBuilderIndexRoute
  '/sp-home': typeof SpHomeIndexRoute
  '/sp-invite': typeof SpInviteIndexRoute
  '/accounts-payable/manage': typeof AuthenticatedAccountsPayableManageRoute
  '/accounts-payable/sp-payment-methods': typeof AuthenticatedAccountsPayableSpPaymentMethodsRoute
  '/clients/$id': typeof AuthenticatedClientsIdRoute
  '/close-out/$workOrderId': typeof AuthenticatedCloseOutWorkOrderIdRoute
  '/entities/$entityId': typeof AuthenticatedEntitiesEntityIdRoute
  '/live-map/alerts': typeof AuthenticatedLiveMapAlertsRoute
  '/locations/$id': typeof AuthenticatedLocationsIdRoute
  '/procurement/$requestId': typeof AuthenticatedProcurementRequestIdRoute
  '/procurement/accounts': typeof AuthenticatedProcurementAccountsRoute
  '/procurement/calendar': typeof AuthenticatedProcurementCalendarRoute
  '/procurement/new': typeof AuthenticatedProcurementNewRoute
  '/procurement/overview': typeof AuthenticatedProcurementOverviewRoute
  '/procurement/returns': typeof AuthenticatedProcurementReturnsRoute
  '/procurement/storage-units': typeof AuthenticatedProcurementStorageUnitsRoute
  '/proposals/manage': typeof AuthenticatedProposalsManageRoute
  '/roles-permissions/$roleId': typeof AuthenticatedRolesPermissionsRoleIdRoute
  '/roles-permissions/compare': typeof AuthenticatedRolesPermissionsCompareRoute
  '/service-providers/$id': typeof AuthenticatedServiceProvidersIdRoute
  '/short-links/$linkId': typeof AuthenticatedShortLinksLinkIdRoute
  '/user-management/$userId': typeof AuthenticatedUserManagementUserIdRoute
  '/sso/callback': typeof UnauthenticatedSsoCallbackRoute
  '/clients/$id/edit-client-coverage': typeof ClientsIdEditClientCoverageRoute
  '/clients/add-new-client': typeof ClientsAddNewClientAddNewClientLayoutRouteWithChildren
  '/entities/create-entity/add-users': typeof EntitiesCreateEntityAddUsersRoute
  '/entities/create-entity/success': typeof EntitiesCreateEntitySuccessRoute
  '/service-providers/onboarding': typeof ServiceProvidersOnboardingOnboardingLayoutRouteWithChildren
  '/sp-invite/review': typeof SpInviteReviewReviewLayoutRouteWithChildren
  '/user-management/add-user/$userId': typeof UserManagementAddUserUserIdRoute
  '/accounts-payable': typeof AuthenticatedAccountsPayableIndexRoute
  '/accounts-receivable': typeof AuthenticatedAccountsReceivableIndexRoute
  '/all-files': typeof AuthenticatedAllFilesIndexRoute
  '/assets': typeof AuthenticatedAssetsIndexRoute
  '/chat': typeof AuthenticatedChatIndexRoute
  '/check-in-out': typeof AuthenticatedCheckInOutIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/close-out': typeof AuthenticatedCloseOutIndexRoute
  '/dispatch-queue': typeof AuthenticatedDispatchQueueIndexRoute
  '/email-ai': typeof AuthenticatedEmailAiIndexRoute
  '/entities': typeof AuthenticatedEntitiesIndexRoute
  '/files': typeof AuthenticatedFilesIndexRoute
  '/fm-integrations': typeof AuthenticatedFmIntegrationsIndexRoute
  '/form-manager': typeof AuthenticatedFormManagerIndexRoute
  '/live-map': typeof AuthenticatedLiveMapIndexRoute
  '/locations': typeof AuthenticatedLocationsIndexRoute
  '/my-tasks': typeof AuthenticatedMyTasksIndexRoute
  '/procurement': typeof AuthenticatedProcurementIndexRoute
  '/proposals': typeof AuthenticatedProposalsIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/roles-permissions': typeof AuthenticatedRolesPermissionsIndexRoute
  '/service-providers': typeof AuthenticatedServiceProvidersIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/short-links': typeof AuthenticatedShortLinksIndexRoute
  '/sp-calendar': typeof AuthenticatedSpCalendarIndexRoute
  '/user-management': typeof AuthenticatedUserManagementIndexRoute
  '/work-orders': typeof AuthenticatedWorkOrdersIndexRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordIndexRoute
  '/login': typeof UnauthenticatedLoginIndexRoute
  '/reset-link-expiry': typeof UnauthenticatedResetLinkExpiryIndexRoute
  '/reset-password': typeof UnauthenticatedResetPasswordIndexRoute
  '/entities/create-entity': typeof EntitiesCreateEntityIndexRoute
  '/form-builder/editor': typeof FormBuilderEditorIndexRoute
  '/roles-permissions/assign-permissions': typeof RolesPermissionsAssignPermissionsIndexRoute
  '/sp-payment/$token': typeof SpPaymentTokenIndexRoute
  '/sp-visit-form/$token': typeof SpVisitFormTokenIndexRoute
  '/sp-w9/$token': typeof SpW9TokenIndexRoute
  '/user-management/add-user': typeof UserManagementAddUserIndexRoute
  '/work-orders/add-work-order': typeof WorkOrdersAddWorkOrderIndexRoute
  '/files/s/$token': typeof AuthenticatedFilesSTokenRoute
  '/procurement/pricing/$pricingRequestId': typeof AuthenticatedProcurementPricingPricingRequestIdRoute
  '/form-builder/assignments/$category': typeof FormBuilderFormBuilderLayoutAssignmentsCategoryRoute
  '/service-providers/$id/alignment': typeof ServiceProvidersIdAlignmentAlignmentLayoutRouteWithChildren
  '/clients/team-assignments': typeof AuthenticatedClientsTeamAssignmentsIndexRoute
  '/mobile/chat': typeof AuthenticatedMobileChatIndexRoute
  '/mobile/schedule': typeof AuthenticatedMobileScheduleIndexRoute
  '/mobile/work-order': typeof AuthenticatedMobileWorkOrderIndexRoute
  '/procurement/pricing': typeof AuthenticatedProcurementPricingIndexRoute
  '/service-providers/reactive-hire-requests': typeof AuthenticatedServiceProvidersReactiveHireRequestsIndexRoute
  '/service-providers/w9-requests': typeof AuthenticatedServiceProvidersW9RequestsIndexRoute
  '/work-orders/$workOrderId': typeof AuthenticatedWorkOrdersWorkOrderIdIndexRoute
  '/form-builder/assignments': typeof FormBuilderFormBuilderLayoutAssignmentsIndexRoute
  '/form-builder/templates': typeof FormBuilderFormBuilderLayoutTemplatesIndexRoute
  '/sp-invite/review/alignment-scheduled': typeof SpInviteReviewAlignmentScheduledIndexRoute
  '/work-orders/$workOrderId/accept-work-order': typeof WorkOrdersWorkOrderIdAcceptWorkOrderIndexRoute
  '/work-orders/$workOrderId/add-visit': typeof WorkOrdersWorkOrderIdAddVisitIndexRoute
  '/work-orders/$workOrderId/checkIn': typeof WorkOrdersWorkOrderIdCheckInIndexRoute
  '/work-orders/$workOrderId/edit-work-order': typeof WorkOrdersWorkOrderIdEditWorkOrderIndexRoute
  '/work-orders/$workOrderId/$visitId/resolved-forms': typeof AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRoute
  '/form-builder/templates/$id/edit': typeof FormBuilderFormBuilderLayoutTemplatesIdEditRoute
  '/work-orders/$workOrderId/$visitId': typeof AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRoute
  '/clients/$id/edit-rates/labor-fee': typeof ClientsIdEditRatesLaborFeeIndexRoute
  '/clients/add-new-client/$stepId': typeof ClientsAddNewClientAddNewClientLayoutStepIdIndexRoute
  '/service-providers/onboarding/complete-onboarding': typeof ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRoute
  '/sp-invite/review/complete-submission': typeof SpInviteReviewReviewLayoutCompleteSubmissionIndexRoute
  '/work-orders/$workOrderId/$visitId/assessment-details': typeof WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRoute
  '/work-orders/$workOrderId/$visitId/edit': typeof WorkOrdersWorkOrderIdVisitIdEditIndexRoute
  '/work-orders/$workOrderId/$visitId/form-preview': typeof WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRoute
  '/work-orders/$workOrderId/accept-work-order/work-order-accepted': typeof WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRoute
  '/work-orders/$workOrderId/accept-work-order/work-order-filled': typeof WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRoute
  '/work-orders/$workOrderId/$visitId/assign-service-provider/request-provider': typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRoute
  '/mobile/work-order/accept/$Id': typeof AuthenticatedMobileWorkOrderAcceptIdIndexRoute
  '/mobile/work-order/check-in/$id': typeof AuthenticatedMobileWorkOrderCheckInIdIndexRoute
  '/mobile/work-order/details/$id': typeof AuthenticatedMobileWorkOrderDetailsIdIndexRoute
  '/mobile/work-order/jobsite-assessment/$id': typeof AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRoute
  '/work-orders/$workOrderId/proposal/create': typeof AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRoute
  '/service-providers/$id/alignment/$providerType': typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRoute
  '/service-providers/onboarding/$providerType/$stepId': typeof ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRoute
  '/sp-invite/review/$providerType/$stepId': typeof SpInviteReviewReviewLayoutProviderTypeStepIdIndexRoute
  '/work-orders/$workOrderId/$visitId/assign-service-provider': typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRoute
  '/service-providers/$id/alignment/$providerType/$stepId': typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRoute
  '/service-providers/$id/alignment/$providerType/summary': typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/form-builder/_formBuilderLayout': typeof FormBuilderFormBuilderLayoutRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/sp-home/': typeof SpHomeIndexRoute
  '/sp-invite/': typeof SpInviteIndexRoute
  '/_authenticated/accounts-payable/manage': typeof AuthenticatedAccountsPayableManageRoute
  '/_authenticated/accounts-payable/sp-payment-methods': typeof AuthenticatedAccountsPayableSpPaymentMethodsRoute
  '/_authenticated/clients/$id': typeof AuthenticatedClientsIdRoute
  '/_authenticated/close-out/$workOrderId': typeof AuthenticatedCloseOutWorkOrderIdRoute
  '/_authenticated/entities/$entityId': typeof AuthenticatedEntitiesEntityIdRoute
  '/_authenticated/live-map/alerts': typeof AuthenticatedLiveMapAlertsRoute
  '/_authenticated/locations/$id': typeof AuthenticatedLocationsIdRoute
  '/_authenticated/procurement/$requestId': typeof AuthenticatedProcurementRequestIdRoute
  '/_authenticated/procurement/accounts': typeof AuthenticatedProcurementAccountsRoute
  '/_authenticated/procurement/calendar': typeof AuthenticatedProcurementCalendarRoute
  '/_authenticated/procurement/new': typeof AuthenticatedProcurementNewRoute
  '/_authenticated/procurement/overview': typeof AuthenticatedProcurementOverviewRoute
  '/_authenticated/procurement/returns': typeof AuthenticatedProcurementReturnsRoute
  '/_authenticated/procurement/storage-units': typeof AuthenticatedProcurementStorageUnitsRoute
  '/_authenticated/proposals/manage': typeof AuthenticatedProposalsManageRoute
  '/_authenticated/roles-permissions/$roleId': typeof AuthenticatedRolesPermissionsRoleIdRoute
  '/_authenticated/roles-permissions/compare': typeof AuthenticatedRolesPermissionsCompareRoute
  '/_authenticated/service-providers/$id': typeof AuthenticatedServiceProvidersIdRoute
  '/_authenticated/short-links/$linkId': typeof AuthenticatedShortLinksLinkIdRoute
  '/_authenticated/user-management/$userId': typeof AuthenticatedUserManagementUserIdRoute
  '/_unauthenticated/sso/callback': typeof UnauthenticatedSsoCallbackRoute
  '/clients/$id/edit-client-coverage': typeof ClientsIdEditClientCoverageRoute
  '/clients/add-new-client/_addNewClientLayout': typeof ClientsAddNewClientAddNewClientLayoutRouteWithChildren
  '/entities/create-entity/add-users': typeof EntitiesCreateEntityAddUsersRoute
  '/entities/create-entity/success': typeof EntitiesCreateEntitySuccessRoute
  '/service-providers/onboarding/_onboardingLayout': typeof ServiceProvidersOnboardingOnboardingLayoutRouteWithChildren
  '/sp-invite/review/_reviewLayout': typeof SpInviteReviewReviewLayoutRouteWithChildren
  '/user-management/add-user/$userId': typeof UserManagementAddUserUserIdRoute
  '/_authenticated/accounts-payable/': typeof AuthenticatedAccountsPayableIndexRoute
  '/_authenticated/accounts-receivable/': typeof AuthenticatedAccountsReceivableIndexRoute
  '/_authenticated/all-files/': typeof AuthenticatedAllFilesIndexRoute
  '/_authenticated/assets/': typeof AuthenticatedAssetsIndexRoute
  '/_authenticated/chat/': typeof AuthenticatedChatIndexRoute
  '/_authenticated/check-in-out/': typeof AuthenticatedCheckInOutIndexRoute
  '/_authenticated/clients/': typeof AuthenticatedClientsIndexRoute
  '/_authenticated/close-out/': typeof AuthenticatedCloseOutIndexRoute
  '/_authenticated/dispatch-queue/': typeof AuthenticatedDispatchQueueIndexRoute
  '/_authenticated/email-ai/': typeof AuthenticatedEmailAiIndexRoute
  '/_authenticated/entities/': typeof AuthenticatedEntitiesIndexRoute
  '/_authenticated/files/': typeof AuthenticatedFilesIndexRoute
  '/_authenticated/fm-integrations/': typeof AuthenticatedFmIntegrationsIndexRoute
  '/_authenticated/form-builder/': typeof AuthenticatedFormBuilderIndexRoute
  '/_authenticated/form-manager/': typeof AuthenticatedFormManagerIndexRoute
  '/_authenticated/live-map/': typeof AuthenticatedLiveMapIndexRoute
  '/_authenticated/locations/': typeof AuthenticatedLocationsIndexRoute
  '/_authenticated/my-tasks/': typeof AuthenticatedMyTasksIndexRoute
  '/_authenticated/procurement/': typeof AuthenticatedProcurementIndexRoute
  '/_authenticated/proposals/': typeof AuthenticatedProposalsIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/roles-permissions/': typeof AuthenticatedRolesPermissionsIndexRoute
  '/_authenticated/service-providers/': typeof AuthenticatedServiceProvidersIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/short-links/': typeof AuthenticatedShortLinksIndexRoute
  '/_authenticated/sp-calendar/': typeof AuthenticatedSpCalendarIndexRoute
  '/_authenticated/user-management/': typeof AuthenticatedUserManagementIndexRoute
  '/_authenticated/work-orders/': typeof AuthenticatedWorkOrdersIndexRoute
  '/_unauthenticated/forgot-password/': typeof UnauthenticatedForgotPasswordIndexRoute
  '/_unauthenticated/login/': typeof UnauthenticatedLoginIndexRoute
  '/_unauthenticated/reset-link-expiry/': typeof UnauthenticatedResetLinkExpiryIndexRoute
  '/_unauthenticated/reset-password/': typeof UnauthenticatedResetPasswordIndexRoute
  '/entities/create-entity/': typeof EntitiesCreateEntityIndexRoute
  '/form-builder/editor/': typeof FormBuilderEditorIndexRoute
  '/roles-permissions/assign-permissions/': typeof RolesPermissionsAssignPermissionsIndexRoute
  '/sp-payment/$token/': typeof SpPaymentTokenIndexRoute
  '/sp-visit-form/$token/': typeof SpVisitFormTokenIndexRoute
  '/sp-w9/$token/': typeof SpW9TokenIndexRoute
  '/user-management/add-user/': typeof UserManagementAddUserIndexRoute
  '/work-orders/add-work-order/': typeof WorkOrdersAddWorkOrderIndexRoute
  '/_authenticated/files/s/$token': typeof AuthenticatedFilesSTokenRoute
  '/_authenticated/procurement/pricing/$pricingRequestId': typeof AuthenticatedProcurementPricingPricingRequestIdRoute
  '/form-builder/_formBuilderLayout/assignments/$category': typeof FormBuilderFormBuilderLayoutAssignmentsCategoryRoute
  '/service-providers/$id/alignment/_alignmentLayout': typeof ServiceProvidersIdAlignmentAlignmentLayoutRouteWithChildren
  '/_authenticated/clients/team-assignments/': typeof AuthenticatedClientsTeamAssignmentsIndexRoute
  '/_authenticated/mobile/chat/': typeof AuthenticatedMobileChatIndexRoute
  '/_authenticated/mobile/schedule/': typeof AuthenticatedMobileScheduleIndexRoute
  '/_authenticated/mobile/work-order/': typeof AuthenticatedMobileWorkOrderIndexRoute
  '/_authenticated/procurement/pricing/': typeof AuthenticatedProcurementPricingIndexRoute
  '/_authenticated/service-providers/reactive-hire-requests/': typeof AuthenticatedServiceProvidersReactiveHireRequestsIndexRoute
  '/_authenticated/service-providers/w9-requests/': typeof AuthenticatedServiceProvidersW9RequestsIndexRoute
  '/_authenticated/work-orders/$workOrderId/': typeof AuthenticatedWorkOrdersWorkOrderIdIndexRoute
  '/form-builder/_formBuilderLayout/assignments/': typeof FormBuilderFormBuilderLayoutAssignmentsIndexRoute
  '/form-builder/_formBuilderLayout/templates/': typeof FormBuilderFormBuilderLayoutTemplatesIndexRoute
  '/sp-invite/review/alignment-scheduled/': typeof SpInviteReviewAlignmentScheduledIndexRoute
  '/work-orders/$workOrderId/accept-work-order/': typeof WorkOrdersWorkOrderIdAcceptWorkOrderIndexRoute
  '/work-orders/$workOrderId/add-visit/': typeof WorkOrdersWorkOrderIdAddVisitIndexRoute
  '/work-orders/$workOrderId/checkIn/': typeof WorkOrdersWorkOrderIdCheckInIndexRoute
  '/work-orders/$workOrderId/edit-work-order/': typeof WorkOrdersWorkOrderIdEditWorkOrderIndexRoute
  '/_authenticated/work-orders/$workOrderId/$visitId/resolved-forms': typeof AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRoute
  '/form-builder/_formBuilderLayout/templates/$id/edit': typeof FormBuilderFormBuilderLayoutTemplatesIdEditRoute
  '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout': typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteWithChildren
  '/_authenticated/work-orders/$workOrderId/$visitId/': typeof AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRoute
  '/clients/$id/edit-rates/labor-fee/': typeof ClientsIdEditRatesLaborFeeIndexRoute
  '/clients/add-new-client/_addNewClientLayout/$stepId/': typeof ClientsAddNewClientAddNewClientLayoutStepIdIndexRoute
  '/service-providers/onboarding/_onboardingLayout/complete-onboarding/': typeof ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRoute
  '/sp-invite/review/_reviewLayout/complete-submission/': typeof SpInviteReviewReviewLayoutCompleteSubmissionIndexRoute
  '/work-orders/$workOrderId/$visitId/assessment-details/': typeof WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRoute
  '/work-orders/$workOrderId/$visitId/edit/': typeof WorkOrdersWorkOrderIdVisitIdEditIndexRoute
  '/work-orders/$workOrderId/$visitId/form-preview/': typeof WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRoute
  '/work-orders/$workOrderId/accept-work-order/work-order-accepted/': typeof WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRoute
  '/work-orders/$workOrderId/accept-work-order/work-order-filled/': typeof WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRoute
  '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/request-provider': typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRoute
  '/_authenticated/mobile/work-order/accept/$Id/': typeof AuthenticatedMobileWorkOrderAcceptIdIndexRoute
  '/_authenticated/mobile/work-order/check-in/$id/': typeof AuthenticatedMobileWorkOrderCheckInIdIndexRoute
  '/_authenticated/mobile/work-order/details/$id/': typeof AuthenticatedMobileWorkOrderDetailsIdIndexRoute
  '/_authenticated/mobile/work-order/jobsite-assessment/$id/': typeof AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRoute
  '/_authenticated/work-orders/$workOrderId/proposal/create/': typeof AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRoute
  '/service-providers/$id/alignment/_alignmentLayout/$providerType/': typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRoute
  '/service-providers/onboarding/_onboardingLayout/$providerType/$stepId/': typeof ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRoute
  '/sp-invite/review/_reviewLayout/$providerType/$stepId/': typeof SpInviteReviewReviewLayoutProviderTypeStepIdIndexRoute
  '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/': typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRoute
  '/service-providers/$id/alignment/_alignmentLayout/$providerType/$stepId/': typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRoute
  '/service-providers/$id/alignment/_alignmentLayout/$providerType/summary/': typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/form-builder'
    | '/sp-home/'
    | '/sp-invite/'
    | '/accounts-payable/manage'
    | '/accounts-payable/sp-payment-methods'
    | '/clients/$id'
    | '/close-out/$workOrderId'
    | '/entities/$entityId'
    | '/live-map/alerts'
    | '/locations/$id'
    | '/procurement/$requestId'
    | '/procurement/accounts'
    | '/procurement/calendar'
    | '/procurement/new'
    | '/procurement/overview'
    | '/procurement/returns'
    | '/procurement/storage-units'
    | '/proposals/manage'
    | '/roles-permissions/$roleId'
    | '/roles-permissions/compare'
    | '/service-providers/$id'
    | '/short-links/$linkId'
    | '/user-management/$userId'
    | '/sso/callback'
    | '/clients/$id/edit-client-coverage'
    | '/clients/add-new-client'
    | '/entities/create-entity/add-users'
    | '/entities/create-entity/success'
    | '/service-providers/onboarding'
    | '/sp-invite/review'
    | '/user-management/add-user/$userId'
    | '/accounts-payable/'
    | '/accounts-receivable/'
    | '/all-files/'
    | '/assets/'
    | '/chat/'
    | '/check-in-out/'
    | '/clients/'
    | '/close-out/'
    | '/dispatch-queue/'
    | '/email-ai/'
    | '/entities/'
    | '/files/'
    | '/fm-integrations/'
    | '/form-builder/'
    | '/form-manager/'
    | '/live-map/'
    | '/locations/'
    | '/my-tasks/'
    | '/procurement/'
    | '/proposals/'
    | '/reports/'
    | '/roles-permissions/'
    | '/service-providers/'
    | '/settings/'
    | '/short-links/'
    | '/sp-calendar/'
    | '/user-management/'
    | '/work-orders/'
    | '/forgot-password/'
    | '/login/'
    | '/reset-link-expiry/'
    | '/reset-password/'
    | '/entities/create-entity/'
    | '/form-builder/editor/'
    | '/roles-permissions/assign-permissions/'
    | '/sp-payment/$token/'
    | '/sp-visit-form/$token/'
    | '/sp-w9/$token/'
    | '/user-management/add-user/'
    | '/work-orders/add-work-order/'
    | '/files/s/$token'
    | '/procurement/pricing/$pricingRequestId'
    | '/form-builder/assignments/$category'
    | '/service-providers/$id/alignment'
    | '/clients/team-assignments/'
    | '/mobile/chat/'
    | '/mobile/schedule/'
    | '/mobile/work-order/'
    | '/procurement/pricing/'
    | '/service-providers/reactive-hire-requests/'
    | '/service-providers/w9-requests/'
    | '/work-orders/$workOrderId/'
    | '/form-builder/assignments/'
    | '/form-builder/templates/'
    | '/sp-invite/review/alignment-scheduled/'
    | '/work-orders/$workOrderId/accept-work-order/'
    | '/work-orders/$workOrderId/add-visit/'
    | '/work-orders/$workOrderId/checkIn/'
    | '/work-orders/$workOrderId/edit-work-order/'
    | '/work-orders/$workOrderId/$visitId/resolved-forms'
    | '/form-builder/templates/$id/edit'
    | '/work-orders/$workOrderId/$visitId/assign-service-provider'
    | '/work-orders/$workOrderId/$visitId/'
    | '/clients/$id/edit-rates/labor-fee/'
    | '/clients/add-new-client/$stepId/'
    | '/service-providers/onboarding/complete-onboarding/'
    | '/sp-invite/review/complete-submission/'
    | '/work-orders/$workOrderId/$visitId/assessment-details/'
    | '/work-orders/$workOrderId/$visitId/edit/'
    | '/work-orders/$workOrderId/$visitId/form-preview/'
    | '/work-orders/$workOrderId/accept-work-order/work-order-accepted/'
    | '/work-orders/$workOrderId/accept-work-order/work-order-filled/'
    | '/work-orders/$workOrderId/$visitId/assign-service-provider/request-provider'
    | '/mobile/work-order/accept/$Id/'
    | '/mobile/work-order/check-in/$id/'
    | '/mobile/work-order/details/$id/'
    | '/mobile/work-order/jobsite-assessment/$id/'
    | '/work-orders/$workOrderId/proposal/create/'
    | '/service-providers/$id/alignment/$providerType/'
    | '/service-providers/onboarding/$providerType/$stepId/'
    | '/sp-invite/review/$providerType/$stepId/'
    | '/work-orders/$workOrderId/$visitId/assign-service-provider/'
    | '/service-providers/$id/alignment/$providerType/$stepId/'
    | '/service-providers/$id/alignment/$providerType/summary/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/form-builder'
    | '/sp-home'
    | '/sp-invite'
    | '/accounts-payable/manage'
    | '/accounts-payable/sp-payment-methods'
    | '/clients/$id'
    | '/close-out/$workOrderId'
    | '/entities/$entityId'
    | '/live-map/alerts'
    | '/locations/$id'
    | '/procurement/$requestId'
    | '/procurement/accounts'
    | '/procurement/calendar'
    | '/procurement/new'
    | '/procurement/overview'
    | '/procurement/returns'
    | '/procurement/storage-units'
    | '/proposals/manage'
    | '/roles-permissions/$roleId'
    | '/roles-permissions/compare'
    | '/service-providers/$id'
    | '/short-links/$linkId'
    | '/user-management/$userId'
    | '/sso/callback'
    | '/clients/$id/edit-client-coverage'
    | '/clients/add-new-client'
    | '/entities/create-entity/add-users'
    | '/entities/create-entity/success'
    | '/service-providers/onboarding'
    | '/sp-invite/review'
    | '/user-management/add-user/$userId'
    | '/accounts-payable'
    | '/accounts-receivable'
    | '/all-files'
    | '/assets'
    | '/chat'
    | '/check-in-out'
    | '/clients'
    | '/close-out'
    | '/dispatch-queue'
    | '/email-ai'
    | '/entities'
    | '/files'
    | '/fm-integrations'
    | '/form-manager'
    | '/live-map'
    | '/locations'
    | '/my-tasks'
    | '/procurement'
    | '/proposals'
    | '/reports'
    | '/roles-permissions'
    | '/service-providers'
    | '/settings'
    | '/short-links'
    | '/sp-calendar'
    | '/user-management'
    | '/work-orders'
    | '/forgot-password'
    | '/login'
    | '/reset-link-expiry'
    | '/reset-password'
    | '/entities/create-entity'
    | '/form-builder/editor'
    | '/roles-permissions/assign-permissions'
    | '/sp-payment/$token'
    | '/sp-visit-form/$token'
    | '/sp-w9/$token'
    | '/user-management/add-user'
    | '/work-orders/add-work-order'
    | '/files/s/$token'
    | '/procurement/pricing/$pricingRequestId'
    | '/form-builder/assignments/$category'
    | '/service-providers/$id/alignment'
    | '/clients/team-assignments'
    | '/mobile/chat'
    | '/mobile/schedule'
    | '/mobile/work-order'
    | '/procurement/pricing'
    | '/service-providers/reactive-hire-requests'
    | '/service-providers/w9-requests'
    | '/work-orders/$workOrderId'
    | '/form-builder/assignments'
    | '/form-builder/templates'
    | '/sp-invite/review/alignment-scheduled'
    | '/work-orders/$workOrderId/accept-work-order'
    | '/work-orders/$workOrderId/add-visit'
    | '/work-orders/$workOrderId/checkIn'
    | '/work-orders/$workOrderId/edit-work-order'
    | '/work-orders/$workOrderId/$visitId/resolved-forms'
    | '/form-builder/templates/$id/edit'
    | '/work-orders/$workOrderId/$visitId'
    | '/clients/$id/edit-rates/labor-fee'
    | '/clients/add-new-client/$stepId'
    | '/service-providers/onboarding/complete-onboarding'
    | '/sp-invite/review/complete-submission'
    | '/work-orders/$workOrderId/$visitId/assessment-details'
    | '/work-orders/$workOrderId/$visitId/edit'
    | '/work-orders/$workOrderId/$visitId/form-preview'
    | '/work-orders/$workOrderId/accept-work-order/work-order-accepted'
    | '/work-orders/$workOrderId/accept-work-order/work-order-filled'
    | '/work-orders/$workOrderId/$visitId/assign-service-provider/request-provider'
    | '/mobile/work-order/accept/$Id'
    | '/mobile/work-order/check-in/$id'
    | '/mobile/work-order/details/$id'
    | '/mobile/work-order/jobsite-assessment/$id'
    | '/work-orders/$workOrderId/proposal/create'
    | '/service-providers/$id/alignment/$providerType'
    | '/service-providers/onboarding/$providerType/$stepId'
    | '/sp-invite/review/$providerType/$stepId'
    | '/work-orders/$workOrderId/$visitId/assign-service-provider'
    | '/service-providers/$id/alignment/$providerType/$stepId'
    | '/service-providers/$id/alignment/$providerType/summary'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/form-builder/_formBuilderLayout'
    | '/_authenticated/'
    | '/sp-home/'
    | '/sp-invite/'
    | '/_authenticated/accounts-payable/manage'
    | '/_authenticated/accounts-payable/sp-payment-methods'
    | '/_authenticated/clients/$id'
    | '/_authenticated/close-out/$workOrderId'
    | '/_authenticated/entities/$entityId'
    | '/_authenticated/live-map/alerts'
    | '/_authenticated/locations/$id'
    | '/_authenticated/procurement/$requestId'
    | '/_authenticated/procurement/accounts'
    | '/_authenticated/procurement/calendar'
    | '/_authenticated/procurement/new'
    | '/_authenticated/procurement/overview'
    | '/_authenticated/procurement/returns'
    | '/_authenticated/procurement/storage-units'
    | '/_authenticated/proposals/manage'
    | '/_authenticated/roles-permissions/$roleId'
    | '/_authenticated/roles-permissions/compare'
    | '/_authenticated/service-providers/$id'
    | '/_authenticated/short-links/$linkId'
    | '/_authenticated/user-management/$userId'
    | '/_unauthenticated/sso/callback'
    | '/clients/$id/edit-client-coverage'
    | '/clients/add-new-client/_addNewClientLayout'
    | '/entities/create-entity/add-users'
    | '/entities/create-entity/success'
    | '/service-providers/onboarding/_onboardingLayout'
    | '/sp-invite/review/_reviewLayout'
    | '/user-management/add-user/$userId'
    | '/_authenticated/accounts-payable/'
    | '/_authenticated/accounts-receivable/'
    | '/_authenticated/all-files/'
    | '/_authenticated/assets/'
    | '/_authenticated/chat/'
    | '/_authenticated/check-in-out/'
    | '/_authenticated/clients/'
    | '/_authenticated/close-out/'
    | '/_authenticated/dispatch-queue/'
    | '/_authenticated/email-ai/'
    | '/_authenticated/entities/'
    | '/_authenticated/files/'
    | '/_authenticated/fm-integrations/'
    | '/_authenticated/form-builder/'
    | '/_authenticated/form-manager/'
    | '/_authenticated/live-map/'
    | '/_authenticated/locations/'
    | '/_authenticated/my-tasks/'
    | '/_authenticated/procurement/'
    | '/_authenticated/proposals/'
    | '/_authenticated/reports/'
    | '/_authenticated/roles-permissions/'
    | '/_authenticated/service-providers/'
    | '/_authenticated/settings/'
    | '/_authenticated/short-links/'
    | '/_authenticated/sp-calendar/'
    | '/_authenticated/user-management/'
    | '/_authenticated/work-orders/'
    | '/_unauthenticated/forgot-password/'
    | '/_unauthenticated/login/'
    | '/_unauthenticated/reset-link-expiry/'
    | '/_unauthenticated/reset-password/'
    | '/entities/create-entity/'
    | '/form-builder/editor/'
    | '/roles-permissions/assign-permissions/'
    | '/sp-payment/$token/'
    | '/sp-visit-form/$token/'
    | '/sp-w9/$token/'
    | '/user-management/add-user/'
    | '/work-orders/add-work-order/'
    | '/_authenticated/files/s/$token'
    | '/_authenticated/procurement/pricing/$pricingRequestId'
    | '/form-builder/_formBuilderLayout/assignments/$category'
    | '/service-providers/$id/alignment/_alignmentLayout'
    | '/_authenticated/clients/team-assignments/'
    | '/_authenticated/mobile/chat/'
    | '/_authenticated/mobile/schedule/'
    | '/_authenticated/mobile/work-order/'
    | '/_authenticated/procurement/pricing/'
    | '/_authenticated/service-providers/reactive-hire-requests/'
    | '/_authenticated/service-providers/w9-requests/'
    | '/_authenticated/work-orders/$workOrderId/'
    | '/form-builder/_formBuilderLayout/assignments/'
    | '/form-builder/_formBuilderLayout/templates/'
    | '/sp-invite/review/alignment-scheduled/'
    | '/work-orders/$workOrderId/accept-work-order/'
    | '/work-orders/$workOrderId/add-visit/'
    | '/work-orders/$workOrderId/checkIn/'
    | '/work-orders/$workOrderId/edit-work-order/'
    | '/_authenticated/work-orders/$workOrderId/$visitId/resolved-forms'
    | '/form-builder/_formBuilderLayout/templates/$id/edit'
    | '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout'
    | '/_authenticated/work-orders/$workOrderId/$visitId/'
    | '/clients/$id/edit-rates/labor-fee/'
    | '/clients/add-new-client/_addNewClientLayout/$stepId/'
    | '/service-providers/onboarding/_onboardingLayout/complete-onboarding/'
    | '/sp-invite/review/_reviewLayout/complete-submission/'
    | '/work-orders/$workOrderId/$visitId/assessment-details/'
    | '/work-orders/$workOrderId/$visitId/edit/'
    | '/work-orders/$workOrderId/$visitId/form-preview/'
    | '/work-orders/$workOrderId/accept-work-order/work-order-accepted/'
    | '/work-orders/$workOrderId/accept-work-order/work-order-filled/'
    | '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/request-provider'
    | '/_authenticated/mobile/work-order/accept/$Id/'
    | '/_authenticated/mobile/work-order/check-in/$id/'
    | '/_authenticated/mobile/work-order/details/$id/'
    | '/_authenticated/mobile/work-order/jobsite-assessment/$id/'
    | '/_authenticated/work-orders/$workOrderId/proposal/create/'
    | '/service-providers/$id/alignment/_alignmentLayout/$providerType/'
    | '/service-providers/onboarding/_onboardingLayout/$providerType/$stepId/'
    | '/sp-invite/review/_reviewLayout/$providerType/$stepId/'
    | '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/'
    | '/service-providers/$id/alignment/_alignmentLayout/$providerType/$stepId/'
    | '/service-providers/$id/alignment/_alignmentLayout/$providerType/summary/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
  FormBuilderFormBuilderLayoutRoute: typeof FormBuilderFormBuilderLayoutRouteWithChildren
  SpHomeIndexRoute: typeof SpHomeIndexRoute
  SpInviteIndexRoute: typeof SpInviteIndexRoute
  ClientsIdEditClientCoverageRoute: typeof ClientsIdEditClientCoverageRoute
  ClientsAddNewClientAddNewClientLayoutRoute: typeof ClientsAddNewClientAddNewClientLayoutRouteWithChildren
  EntitiesCreateEntityAddUsersRoute: typeof EntitiesCreateEntityAddUsersRoute
  EntitiesCreateEntitySuccessRoute: typeof EntitiesCreateEntitySuccessRoute
  ServiceProvidersOnboardingOnboardingLayoutRoute: typeof ServiceProvidersOnboardingOnboardingLayoutRouteWithChildren
  SpInviteReviewReviewLayoutRoute: typeof SpInviteReviewReviewLayoutRouteWithChildren
  UserManagementAddUserUserIdRoute: typeof UserManagementAddUserUserIdRoute
  EntitiesCreateEntityIndexRoute: typeof EntitiesCreateEntityIndexRoute
  FormBuilderEditorIndexRoute: typeof FormBuilderEditorIndexRoute
  RolesPermissionsAssignPermissionsIndexRoute: typeof RolesPermissionsAssignPermissionsIndexRoute
  SpPaymentTokenIndexRoute: typeof SpPaymentTokenIndexRoute
  SpVisitFormTokenIndexRoute: typeof SpVisitFormTokenIndexRoute
  SpW9TokenIndexRoute: typeof SpW9TokenIndexRoute
  UserManagementAddUserIndexRoute: typeof UserManagementAddUserIndexRoute
  WorkOrdersAddWorkOrderIndexRoute: typeof WorkOrdersAddWorkOrderIndexRoute
  ServiceProvidersIdAlignmentAlignmentLayoutRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutRouteWithChildren
  SpInviteReviewAlignmentScheduledIndexRoute: typeof SpInviteReviewAlignmentScheduledIndexRoute
  WorkOrdersWorkOrderIdAcceptWorkOrderIndexRoute: typeof WorkOrdersWorkOrderIdAcceptWorkOrderIndexRoute
  WorkOrdersWorkOrderIdAddVisitIndexRoute: typeof WorkOrdersWorkOrderIdAddVisitIndexRoute
  WorkOrdersWorkOrderIdCheckInIndexRoute: typeof WorkOrdersWorkOrderIdCheckInIndexRoute
  WorkOrdersWorkOrderIdEditWorkOrderIndexRoute: typeof WorkOrdersWorkOrderIdEditWorkOrderIndexRoute
  WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRoute: typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteWithChildren
  ClientsIdEditRatesLaborFeeIndexRoute: typeof ClientsIdEditRatesLaborFeeIndexRoute
  WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRoute: typeof WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRoute
  WorkOrdersWorkOrderIdVisitIdEditIndexRoute: typeof WorkOrdersWorkOrderIdVisitIdEditIndexRoute
  WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRoute: typeof WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRoute
  WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRoute: typeof WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRoute
  WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRoute: typeof WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sp-invite/': {
      id: '/sp-invite/'
      path: '/sp-invite'
      fullPath: '/sp-invite/'
      preLoaderRoute: typeof SpInviteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sp-home/': {
      id: '/sp-home/'
      path: '/sp-home'
      fullPath: '/sp-home/'
      preLoaderRoute: typeof SpHomeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/form-builder/_formBuilderLayout': {
      id: '/form-builder/_formBuilderLayout'
      path: '/form-builder'
      fullPath: '/form-builder'
      preLoaderRoute: typeof FormBuilderFormBuilderLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/add-work-order/': {
      id: '/work-orders/add-work-order/'
      path: '/work-orders/add-work-order'
      fullPath: '/work-orders/add-work-order/'
      preLoaderRoute: typeof WorkOrdersAddWorkOrderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-management/add-user/': {
      id: '/user-management/add-user/'
      path: '/user-management/add-user'
      fullPath: '/user-management/add-user/'
      preLoaderRoute: typeof UserManagementAddUserIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sp-w9/$token/': {
      id: '/sp-w9/$token/'
      path: '/sp-w9/$token'
      fullPath: '/sp-w9/$token/'
      preLoaderRoute: typeof SpW9TokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sp-visit-form/$token/': {
      id: '/sp-visit-form/$token/'
      path: '/sp-visit-form/$token'
      fullPath: '/sp-visit-form/$token/'
      preLoaderRoute: typeof SpVisitFormTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sp-payment/$token/': {
      id: '/sp-payment/$token/'
      path: '/sp-payment/$token'
      fullPath: '/sp-payment/$token/'
      preLoaderRoute: typeof SpPaymentTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roles-permissions/assign-permissions/': {
      id: '/roles-permissions/assign-permissions/'
      path: '/roles-permissions/assign-permissions'
      fullPath: '/roles-permissions/assign-permissions/'
      preLoaderRoute: typeof RolesPermissionsAssignPermissionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form-builder/editor/': {
      id: '/form-builder/editor/'
      path: '/form-builder/editor'
      fullPath: '/form-builder/editor/'
      preLoaderRoute: typeof FormBuilderEditorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entities/create-entity/': {
      id: '/entities/create-entity/'
      path: '/entities/create-entity'
      fullPath: '/entities/create-entity/'
      preLoaderRoute: typeof EntitiesCreateEntityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/reset-password/': {
      id: '/_unauthenticated/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof UnauthenticatedResetPasswordIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/reset-link-expiry/': {
      id: '/_unauthenticated/reset-link-expiry/'
      path: '/reset-link-expiry'
      fullPath: '/reset-link-expiry/'
      preLoaderRoute: typeof UnauthenticatedResetLinkExpiryIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/login/': {
      id: '/_unauthenticated/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof UnauthenticatedLoginIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/forgot-password/': {
      id: '/_unauthenticated/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof UnauthenticatedForgotPasswordIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/work-orders/': {
      id: '/_authenticated/work-orders/'
      path: '/work-orders'
      fullPath: '/work-orders/'
      preLoaderRoute: typeof AuthenticatedWorkOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user-management/': {
      id: '/_authenticated/user-management/'
      path: '/user-management'
      fullPath: '/user-management/'
      preLoaderRoute: typeof AuthenticatedUserManagementIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sp-calendar/': {
      id: '/_authenticated/sp-calendar/'
      path: '/sp-calendar'
      fullPath: '/sp-calendar/'
      preLoaderRoute: typeof AuthenticatedSpCalendarIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/short-links/': {
      id: '/_authenticated/short-links/'
      path: '/short-links'
      fullPath: '/short-links/'
      preLoaderRoute: typeof AuthenticatedShortLinksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/service-providers/': {
      id: '/_authenticated/service-providers/'
      path: '/service-providers'
      fullPath: '/service-providers/'
      preLoaderRoute: typeof AuthenticatedServiceProvidersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles-permissions/': {
      id: '/_authenticated/roles-permissions/'
      path: '/roles-permissions'
      fullPath: '/roles-permissions/'
      preLoaderRoute: typeof AuthenticatedRolesPermissionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/proposals/': {
      id: '/_authenticated/proposals/'
      path: '/proposals'
      fullPath: '/proposals/'
      preLoaderRoute: typeof AuthenticatedProposalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procurement/': {
      id: '/_authenticated/procurement/'
      path: '/procurement'
      fullPath: '/procurement/'
      preLoaderRoute: typeof AuthenticatedProcurementIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-tasks/': {
      id: '/_authenticated/my-tasks/'
      path: '/my-tasks'
      fullPath: '/my-tasks/'
      preLoaderRoute: typeof AuthenticatedMyTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/locations/': {
      id: '/_authenticated/locations/'
      path: '/locations'
      fullPath: '/locations/'
      preLoaderRoute: typeof AuthenticatedLocationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/live-map/': {
      id: '/_authenticated/live-map/'
      path: '/live-map'
      fullPath: '/live-map/'
      preLoaderRoute: typeof AuthenticatedLiveMapIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/form-manager/': {
      id: '/_authenticated/form-manager/'
      path: '/form-manager'
      fullPath: '/form-manager/'
      preLoaderRoute: typeof AuthenticatedFormManagerIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/form-builder/': {
      id: '/_authenticated/form-builder/'
      path: '/form-builder'
      fullPath: '/form-builder/'
      preLoaderRoute: typeof AuthenticatedFormBuilderIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fm-integrations/': {
      id: '/_authenticated/fm-integrations/'
      path: '/fm-integrations'
      fullPath: '/fm-integrations/'
      preLoaderRoute: typeof AuthenticatedFmIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files/': {
      id: '/_authenticated/files/'
      path: '/files'
      fullPath: '/files/'
      preLoaderRoute: typeof AuthenticatedFilesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entities/': {
      id: '/_authenticated/entities/'
      path: '/entities'
      fullPath: '/entities/'
      preLoaderRoute: typeof AuthenticatedEntitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/email-ai/': {
      id: '/_authenticated/email-ai/'
      path: '/email-ai'
      fullPath: '/email-ai/'
      preLoaderRoute: typeof AuthenticatedEmailAiIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dispatch-queue/': {
      id: '/_authenticated/dispatch-queue/'
      path: '/dispatch-queue'
      fullPath: '/dispatch-queue/'
      preLoaderRoute: typeof AuthenticatedDispatchQueueIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/close-out/': {
      id: '/_authenticated/close-out/'
      path: '/close-out'
      fullPath: '/close-out/'
      preLoaderRoute: typeof AuthenticatedCloseOutIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/': {
      id: '/_authenticated/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthenticatedClientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/check-in-out/': {
      id: '/_authenticated/check-in-out/'
      path: '/check-in-out'
      fullPath: '/check-in-out/'
      preLoaderRoute: typeof AuthenticatedCheckInOutIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat/': {
      id: '/_authenticated/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof AuthenticatedChatIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets/': {
      id: '/_authenticated/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof AuthenticatedAssetsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/all-files/': {
      id: '/_authenticated/all-files/'
      path: '/all-files'
      fullPath: '/all-files/'
      preLoaderRoute: typeof AuthenticatedAllFilesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts-receivable/': {
      id: '/_authenticated/accounts-receivable/'
      path: '/accounts-receivable'
      fullPath: '/accounts-receivable/'
      preLoaderRoute: typeof AuthenticatedAccountsReceivableIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts-payable/': {
      id: '/_authenticated/accounts-payable/'
      path: '/accounts-payable'
      fullPath: '/accounts-payable/'
      preLoaderRoute: typeof AuthenticatedAccountsPayableIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/user-management/add-user/$userId': {
      id: '/user-management/add-user/$userId'
      path: '/user-management/add-user/$userId'
      fullPath: '/user-management/add-user/$userId'
      preLoaderRoute: typeof UserManagementAddUserUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sp-invite/review/_reviewLayout': {
      id: '/sp-invite/review/_reviewLayout'
      path: '/sp-invite/review'
      fullPath: '/sp-invite/review'
      preLoaderRoute: typeof SpInviteReviewReviewLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/service-providers/onboarding/_onboardingLayout': {
      id: '/service-providers/onboarding/_onboardingLayout'
      path: '/service-providers/onboarding'
      fullPath: '/service-providers/onboarding'
      preLoaderRoute: typeof ServiceProvidersOnboardingOnboardingLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entities/create-entity/success': {
      id: '/entities/create-entity/success'
      path: '/entities/create-entity/success'
      fullPath: '/entities/create-entity/success'
      preLoaderRoute: typeof EntitiesCreateEntitySuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entities/create-entity/add-users': {
      id: '/entities/create-entity/add-users'
      path: '/entities/create-entity/add-users'
      fullPath: '/entities/create-entity/add-users'
      preLoaderRoute: typeof EntitiesCreateEntityAddUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/add-new-client/_addNewClientLayout': {
      id: '/clients/add-new-client/_addNewClientLayout'
      path: '/clients/add-new-client'
      fullPath: '/clients/add-new-client'
      preLoaderRoute: typeof ClientsAddNewClientAddNewClientLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$id/edit-client-coverage': {
      id: '/clients/$id/edit-client-coverage'
      path: '/clients/$id/edit-client-coverage'
      fullPath: '/clients/$id/edit-client-coverage'
      preLoaderRoute: typeof ClientsIdEditClientCoverageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/sso/callback': {
      id: '/_unauthenticated/sso/callback'
      path: '/sso/callback'
      fullPath: '/sso/callback'
      preLoaderRoute: typeof UnauthenticatedSsoCallbackRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/user-management/$userId': {
      id: '/_authenticated/user-management/$userId'
      path: '/user-management/$userId'
      fullPath: '/user-management/$userId'
      preLoaderRoute: typeof AuthenticatedUserManagementUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/short-links/$linkId': {
      id: '/_authenticated/short-links/$linkId'
      path: '/short-links/$linkId'
      fullPath: '/short-links/$linkId'
      preLoaderRoute: typeof AuthenticatedShortLinksLinkIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/service-providers/$id': {
      id: '/_authenticated/service-providers/$id'
      path: '/service-providers/$id'
      fullPath: '/service-providers/$id'
      preLoaderRoute: typeof AuthenticatedServiceProvidersIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles-permissions/compare': {
      id: '/_authenticated/roles-permissions/compare'
      path: '/roles-permissions/compare'
      fullPath: '/roles-permissions/compare'
      preLoaderRoute: typeof AuthenticatedRolesPermissionsCompareRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles-permissions/$roleId': {
      id: '/_authenticated/roles-permissions/$roleId'
      path: '/roles-permissions/$roleId'
      fullPath: '/roles-permissions/$roleId'
      preLoaderRoute: typeof AuthenticatedRolesPermissionsRoleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/proposals/manage': {
      id: '/_authenticated/proposals/manage'
      path: '/proposals/manage'
      fullPath: '/proposals/manage'
      preLoaderRoute: typeof AuthenticatedProposalsManageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procurement/storage-units': {
      id: '/_authenticated/procurement/storage-units'
      path: '/procurement/storage-units'
      fullPath: '/procurement/storage-units'
      preLoaderRoute: typeof AuthenticatedProcurementStorageUnitsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procurement/returns': {
      id: '/_authenticated/procurement/returns'
      path: '/procurement/returns'
      fullPath: '/procurement/returns'
      preLoaderRoute: typeof AuthenticatedProcurementReturnsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procurement/overview': {
      id: '/_authenticated/procurement/overview'
      path: '/procurement/overview'
      fullPath: '/procurement/overview'
      preLoaderRoute: typeof AuthenticatedProcurementOverviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procurement/new': {
      id: '/_authenticated/procurement/new'
      path: '/procurement/new'
      fullPath: '/procurement/new'
      preLoaderRoute: typeof AuthenticatedProcurementNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procurement/calendar': {
      id: '/_authenticated/procurement/calendar'
      path: '/procurement/calendar'
      fullPath: '/procurement/calendar'
      preLoaderRoute: typeof AuthenticatedProcurementCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procurement/accounts': {
      id: '/_authenticated/procurement/accounts'
      path: '/procurement/accounts'
      fullPath: '/procurement/accounts'
      preLoaderRoute: typeof AuthenticatedProcurementAccountsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procurement/$requestId': {
      id: '/_authenticated/procurement/$requestId'
      path: '/procurement/$requestId'
      fullPath: '/procurement/$requestId'
      preLoaderRoute: typeof AuthenticatedProcurementRequestIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/locations/$id': {
      id: '/_authenticated/locations/$id'
      path: '/locations/$id'
      fullPath: '/locations/$id'
      preLoaderRoute: typeof AuthenticatedLocationsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/live-map/alerts': {
      id: '/_authenticated/live-map/alerts'
      path: '/live-map/alerts'
      fullPath: '/live-map/alerts'
      preLoaderRoute: typeof AuthenticatedLiveMapAlertsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entities/$entityId': {
      id: '/_authenticated/entities/$entityId'
      path: '/entities/$entityId'
      fullPath: '/entities/$entityId'
      preLoaderRoute: typeof AuthenticatedEntitiesEntityIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/close-out/$workOrderId': {
      id: '/_authenticated/close-out/$workOrderId'
      path: '/close-out/$workOrderId'
      fullPath: '/close-out/$workOrderId'
      preLoaderRoute: typeof AuthenticatedCloseOutWorkOrderIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/$id': {
      id: '/_authenticated/clients/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof AuthenticatedClientsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts-payable/sp-payment-methods': {
      id: '/_authenticated/accounts-payable/sp-payment-methods'
      path: '/accounts-payable/sp-payment-methods'
      fullPath: '/accounts-payable/sp-payment-methods'
      preLoaderRoute: typeof AuthenticatedAccountsPayableSpPaymentMethodsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounts-payable/manage': {
      id: '/_authenticated/accounts-payable/manage'
      path: '/accounts-payable/manage'
      fullPath: '/accounts-payable/manage'
      preLoaderRoute: typeof AuthenticatedAccountsPayableManageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/work-orders/$workOrderId/edit-work-order/': {
      id: '/work-orders/$workOrderId/edit-work-order/'
      path: '/work-orders/$workOrderId/edit-work-order'
      fullPath: '/work-orders/$workOrderId/edit-work-order/'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdEditWorkOrderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/$workOrderId/checkIn/': {
      id: '/work-orders/$workOrderId/checkIn/'
      path: '/work-orders/$workOrderId/checkIn'
      fullPath: '/work-orders/$workOrderId/checkIn/'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdCheckInIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/$workOrderId/add-visit/': {
      id: '/work-orders/$workOrderId/add-visit/'
      path: '/work-orders/$workOrderId/add-visit'
      fullPath: '/work-orders/$workOrderId/add-visit/'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdAddVisitIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/$workOrderId/accept-work-order/': {
      id: '/work-orders/$workOrderId/accept-work-order/'
      path: '/work-orders/$workOrderId/accept-work-order'
      fullPath: '/work-orders/$workOrderId/accept-work-order/'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdAcceptWorkOrderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sp-invite/review/alignment-scheduled/': {
      id: '/sp-invite/review/alignment-scheduled/'
      path: '/sp-invite/review/alignment-scheduled'
      fullPath: '/sp-invite/review/alignment-scheduled/'
      preLoaderRoute: typeof SpInviteReviewAlignmentScheduledIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form-builder/_formBuilderLayout/templates/': {
      id: '/form-builder/_formBuilderLayout/templates/'
      path: '/templates'
      fullPath: '/form-builder/templates/'
      preLoaderRoute: typeof FormBuilderFormBuilderLayoutTemplatesIndexRouteImport
      parentRoute: typeof FormBuilderFormBuilderLayoutRoute
    }
    '/form-builder/_formBuilderLayout/assignments/': {
      id: '/form-builder/_formBuilderLayout/assignments/'
      path: '/assignments'
      fullPath: '/form-builder/assignments/'
      preLoaderRoute: typeof FormBuilderFormBuilderLayoutAssignmentsIndexRouteImport
      parentRoute: typeof FormBuilderFormBuilderLayoutRoute
    }
    '/_authenticated/work-orders/$workOrderId/': {
      id: '/_authenticated/work-orders/$workOrderId/'
      path: '/work-orders/$workOrderId'
      fullPath: '/work-orders/$workOrderId/'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/service-providers/w9-requests/': {
      id: '/_authenticated/service-providers/w9-requests/'
      path: '/service-providers/w9-requests'
      fullPath: '/service-providers/w9-requests/'
      preLoaderRoute: typeof AuthenticatedServiceProvidersW9RequestsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/service-providers/reactive-hire-requests/': {
      id: '/_authenticated/service-providers/reactive-hire-requests/'
      path: '/service-providers/reactive-hire-requests'
      fullPath: '/service-providers/reactive-hire-requests/'
      preLoaderRoute: typeof AuthenticatedServiceProvidersReactiveHireRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procurement/pricing/': {
      id: '/_authenticated/procurement/pricing/'
      path: '/procurement/pricing'
      fullPath: '/procurement/pricing/'
      preLoaderRoute: typeof AuthenticatedProcurementPricingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mobile/work-order/': {
      id: '/_authenticated/mobile/work-order/'
      path: '/mobile/work-order'
      fullPath: '/mobile/work-order/'
      preLoaderRoute: typeof AuthenticatedMobileWorkOrderIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mobile/schedule/': {
      id: '/_authenticated/mobile/schedule/'
      path: '/mobile/schedule'
      fullPath: '/mobile/schedule/'
      preLoaderRoute: typeof AuthenticatedMobileScheduleIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mobile/chat/': {
      id: '/_authenticated/mobile/chat/'
      path: '/mobile/chat'
      fullPath: '/mobile/chat/'
      preLoaderRoute: typeof AuthenticatedMobileChatIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/team-assignments/': {
      id: '/_authenticated/clients/team-assignments/'
      path: '/clients/team-assignments'
      fullPath: '/clients/team-assignments/'
      preLoaderRoute: typeof AuthenticatedClientsTeamAssignmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/service-providers/$id/alignment/_alignmentLayout': {
      id: '/service-providers/$id/alignment/_alignmentLayout'
      path: '/service-providers/$id/alignment'
      fullPath: '/service-providers/$id/alignment'
      preLoaderRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form-builder/_formBuilderLayout/assignments/$category': {
      id: '/form-builder/_formBuilderLayout/assignments/$category'
      path: '/assignments/$category'
      fullPath: '/form-builder/assignments/$category'
      preLoaderRoute: typeof FormBuilderFormBuilderLayoutAssignmentsCategoryRouteImport
      parentRoute: typeof FormBuilderFormBuilderLayoutRoute
    }
    '/_authenticated/procurement/pricing/$pricingRequestId': {
      id: '/_authenticated/procurement/pricing/$pricingRequestId'
      path: '/procurement/pricing/$pricingRequestId'
      fullPath: '/procurement/pricing/$pricingRequestId'
      preLoaderRoute: typeof AuthenticatedProcurementPricingPricingRequestIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files/s/$token': {
      id: '/_authenticated/files/s/$token'
      path: '/files/s/$token'
      fullPath: '/files/s/$token'
      preLoaderRoute: typeof AuthenticatedFilesSTokenRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/work-orders/$workOrderId/accept-work-order/work-order-filled/': {
      id: '/work-orders/$workOrderId/accept-work-order/work-order-filled/'
      path: '/work-orders/$workOrderId/accept-work-order/work-order-filled'
      fullPath: '/work-orders/$workOrderId/accept-work-order/work-order-filled/'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/$workOrderId/accept-work-order/work-order-accepted/': {
      id: '/work-orders/$workOrderId/accept-work-order/work-order-accepted/'
      path: '/work-orders/$workOrderId/accept-work-order/work-order-accepted'
      fullPath: '/work-orders/$workOrderId/accept-work-order/work-order-accepted/'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/$workOrderId/$visitId/form-preview/': {
      id: '/work-orders/$workOrderId/$visitId/form-preview/'
      path: '/work-orders/$workOrderId/$visitId/form-preview'
      fullPath: '/work-orders/$workOrderId/$visitId/form-preview/'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/$workOrderId/$visitId/edit/': {
      id: '/work-orders/$workOrderId/$visitId/edit/'
      path: '/work-orders/$workOrderId/$visitId/edit'
      fullPath: '/work-orders/$workOrderId/$visitId/edit/'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdVisitIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/$workOrderId/$visitId/assessment-details/': {
      id: '/work-orders/$workOrderId/$visitId/assessment-details/'
      path: '/work-orders/$workOrderId/$visitId/assessment-details'
      fullPath: '/work-orders/$workOrderId/$visitId/assessment-details/'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sp-invite/review/_reviewLayout/complete-submission/': {
      id: '/sp-invite/review/_reviewLayout/complete-submission/'
      path: '/complete-submission'
      fullPath: '/sp-invite/review/complete-submission/'
      preLoaderRoute: typeof SpInviteReviewReviewLayoutCompleteSubmissionIndexRouteImport
      parentRoute: typeof SpInviteReviewReviewLayoutRoute
    }
    '/service-providers/onboarding/_onboardingLayout/complete-onboarding/': {
      id: '/service-providers/onboarding/_onboardingLayout/complete-onboarding/'
      path: '/complete-onboarding'
      fullPath: '/service-providers/onboarding/complete-onboarding/'
      preLoaderRoute: typeof ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRouteImport
      parentRoute: typeof ServiceProvidersOnboardingOnboardingLayoutRoute
    }
    '/clients/add-new-client/_addNewClientLayout/$stepId/': {
      id: '/clients/add-new-client/_addNewClientLayout/$stepId/'
      path: '/$stepId'
      fullPath: '/clients/add-new-client/$stepId/'
      preLoaderRoute: typeof ClientsAddNewClientAddNewClientLayoutStepIdIndexRouteImport
      parentRoute: typeof ClientsAddNewClientAddNewClientLayoutRoute
    }
    '/clients/$id/edit-rates/labor-fee/': {
      id: '/clients/$id/edit-rates/labor-fee/'
      path: '/clients/$id/edit-rates/labor-fee'
      fullPath: '/clients/$id/edit-rates/labor-fee/'
      preLoaderRoute: typeof ClientsIdEditRatesLaborFeeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/work-orders/$workOrderId/$visitId/': {
      id: '/_authenticated/work-orders/$workOrderId/$visitId/'
      path: '/work-orders/$workOrderId/$visitId'
      fullPath: '/work-orders/$workOrderId/$visitId/'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout': {
      id: '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout'
      path: '/work-orders/$workOrderId/$visitId/assign-service-provider'
      fullPath: '/work-orders/$workOrderId/$visitId/assign-service-provider'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form-builder/_formBuilderLayout/templates/$id/edit': {
      id: '/form-builder/_formBuilderLayout/templates/$id/edit'
      path: '/templates/$id/edit'
      fullPath: '/form-builder/templates/$id/edit'
      preLoaderRoute: typeof FormBuilderFormBuilderLayoutTemplatesIdEditRouteImport
      parentRoute: typeof FormBuilderFormBuilderLayoutRoute
    }
    '/_authenticated/work-orders/$workOrderId/$visitId/resolved-forms': {
      id: '/_authenticated/work-orders/$workOrderId/$visitId/resolved-forms'
      path: '/work-orders/$workOrderId/$visitId/resolved-forms'
      fullPath: '/work-orders/$workOrderId/$visitId/resolved-forms'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/': {
      id: '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/'
      path: '/'
      fullPath: '/work-orders/$workOrderId/$visitId/assign-service-provider/'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRouteImport
      parentRoute: typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRoute
    }
    '/sp-invite/review/_reviewLayout/$providerType/$stepId/': {
      id: '/sp-invite/review/_reviewLayout/$providerType/$stepId/'
      path: '/$providerType/$stepId'
      fullPath: '/sp-invite/review/$providerType/$stepId/'
      preLoaderRoute: typeof SpInviteReviewReviewLayoutProviderTypeStepIdIndexRouteImport
      parentRoute: typeof SpInviteReviewReviewLayoutRoute
    }
    '/service-providers/onboarding/_onboardingLayout/$providerType/$stepId/': {
      id: '/service-providers/onboarding/_onboardingLayout/$providerType/$stepId/'
      path: '/$providerType/$stepId'
      fullPath: '/service-providers/onboarding/$providerType/$stepId/'
      preLoaderRoute: typeof ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRouteImport
      parentRoute: typeof ServiceProvidersOnboardingOnboardingLayoutRoute
    }
    '/service-providers/$id/alignment/_alignmentLayout/$providerType/': {
      id: '/service-providers/$id/alignment/_alignmentLayout/$providerType/'
      path: '/$providerType'
      fullPath: '/service-providers/$id/alignment/$providerType/'
      preLoaderRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRouteImport
      parentRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutRoute
    }
    '/_authenticated/work-orders/$workOrderId/proposal/create/': {
      id: '/_authenticated/work-orders/$workOrderId/proposal/create/'
      path: '/work-orders/$workOrderId/proposal/create'
      fullPath: '/work-orders/$workOrderId/proposal/create/'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mobile/work-order/jobsite-assessment/$id/': {
      id: '/_authenticated/mobile/work-order/jobsite-assessment/$id/'
      path: '/mobile/work-order/jobsite-assessment/$id'
      fullPath: '/mobile/work-order/jobsite-assessment/$id/'
      preLoaderRoute: typeof AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mobile/work-order/details/$id/': {
      id: '/_authenticated/mobile/work-order/details/$id/'
      path: '/mobile/work-order/details/$id'
      fullPath: '/mobile/work-order/details/$id/'
      preLoaderRoute: typeof AuthenticatedMobileWorkOrderDetailsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mobile/work-order/check-in/$id/': {
      id: '/_authenticated/mobile/work-order/check-in/$id/'
      path: '/mobile/work-order/check-in/$id'
      fullPath: '/mobile/work-order/check-in/$id/'
      preLoaderRoute: typeof AuthenticatedMobileWorkOrderCheckInIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mobile/work-order/accept/$Id/': {
      id: '/_authenticated/mobile/work-order/accept/$Id/'
      path: '/mobile/work-order/accept/$Id'
      fullPath: '/mobile/work-order/accept/$Id/'
      preLoaderRoute: typeof AuthenticatedMobileWorkOrderAcceptIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/request-provider': {
      id: '/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/request-provider'
      path: '/request-provider'
      fullPath: '/work-orders/$workOrderId/$visitId/assign-service-provider/request-provider'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRouteImport
      parentRoute: typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRoute
    }
    '/service-providers/$id/alignment/_alignmentLayout/$providerType/summary/': {
      id: '/service-providers/$id/alignment/_alignmentLayout/$providerType/summary/'
      path: '/$providerType/summary'
      fullPath: '/service-providers/$id/alignment/$providerType/summary/'
      preLoaderRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRouteImport
      parentRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutRoute
    }
    '/service-providers/$id/alignment/_alignmentLayout/$providerType/$stepId/': {
      id: '/service-providers/$id/alignment/_alignmentLayout/$providerType/$stepId/'
      path: '/$providerType/$stepId'
      fullPath: '/service-providers/$id/alignment/$providerType/$stepId/'
      preLoaderRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRouteImport
      parentRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAccountsPayableManageRoute: typeof AuthenticatedAccountsPayableManageRoute
  AuthenticatedAccountsPayableSpPaymentMethodsRoute: typeof AuthenticatedAccountsPayableSpPaymentMethodsRoute
  AuthenticatedClientsIdRoute: typeof AuthenticatedClientsIdRoute
  AuthenticatedCloseOutWorkOrderIdRoute: typeof AuthenticatedCloseOutWorkOrderIdRoute
  AuthenticatedEntitiesEntityIdRoute: typeof AuthenticatedEntitiesEntityIdRoute
  AuthenticatedLiveMapAlertsRoute: typeof AuthenticatedLiveMapAlertsRoute
  AuthenticatedLocationsIdRoute: typeof AuthenticatedLocationsIdRoute
  AuthenticatedProcurementRequestIdRoute: typeof AuthenticatedProcurementRequestIdRoute
  AuthenticatedProcurementAccountsRoute: typeof AuthenticatedProcurementAccountsRoute
  AuthenticatedProcurementCalendarRoute: typeof AuthenticatedProcurementCalendarRoute
  AuthenticatedProcurementNewRoute: typeof AuthenticatedProcurementNewRoute
  AuthenticatedProcurementOverviewRoute: typeof AuthenticatedProcurementOverviewRoute
  AuthenticatedProcurementReturnsRoute: typeof AuthenticatedProcurementReturnsRoute
  AuthenticatedProcurementStorageUnitsRoute: typeof AuthenticatedProcurementStorageUnitsRoute
  AuthenticatedProposalsManageRoute: typeof AuthenticatedProposalsManageRoute
  AuthenticatedRolesPermissionsRoleIdRoute: typeof AuthenticatedRolesPermissionsRoleIdRoute
  AuthenticatedRolesPermissionsCompareRoute: typeof AuthenticatedRolesPermissionsCompareRoute
  AuthenticatedServiceProvidersIdRoute: typeof AuthenticatedServiceProvidersIdRoute
  AuthenticatedShortLinksLinkIdRoute: typeof AuthenticatedShortLinksLinkIdRoute
  AuthenticatedUserManagementUserIdRoute: typeof AuthenticatedUserManagementUserIdRoute
  AuthenticatedAccountsPayableIndexRoute: typeof AuthenticatedAccountsPayableIndexRoute
  AuthenticatedAccountsReceivableIndexRoute: typeof AuthenticatedAccountsReceivableIndexRoute
  AuthenticatedAllFilesIndexRoute: typeof AuthenticatedAllFilesIndexRoute
  AuthenticatedAssetsIndexRoute: typeof AuthenticatedAssetsIndexRoute
  AuthenticatedChatIndexRoute: typeof AuthenticatedChatIndexRoute
  AuthenticatedCheckInOutIndexRoute: typeof AuthenticatedCheckInOutIndexRoute
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
  AuthenticatedCloseOutIndexRoute: typeof AuthenticatedCloseOutIndexRoute
  AuthenticatedDispatchQueueIndexRoute: typeof AuthenticatedDispatchQueueIndexRoute
  AuthenticatedEmailAiIndexRoute: typeof AuthenticatedEmailAiIndexRoute
  AuthenticatedEntitiesIndexRoute: typeof AuthenticatedEntitiesIndexRoute
  AuthenticatedFilesIndexRoute: typeof AuthenticatedFilesIndexRoute
  AuthenticatedFmIntegrationsIndexRoute: typeof AuthenticatedFmIntegrationsIndexRoute
  AuthenticatedFormBuilderIndexRoute: typeof AuthenticatedFormBuilderIndexRoute
  AuthenticatedFormManagerIndexRoute: typeof AuthenticatedFormManagerIndexRoute
  AuthenticatedLiveMapIndexRoute: typeof AuthenticatedLiveMapIndexRoute
  AuthenticatedLocationsIndexRoute: typeof AuthenticatedLocationsIndexRoute
  AuthenticatedMyTasksIndexRoute: typeof AuthenticatedMyTasksIndexRoute
  AuthenticatedProcurementIndexRoute: typeof AuthenticatedProcurementIndexRoute
  AuthenticatedProposalsIndexRoute: typeof AuthenticatedProposalsIndexRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
  AuthenticatedRolesPermissionsIndexRoute: typeof AuthenticatedRolesPermissionsIndexRoute
  AuthenticatedServiceProvidersIndexRoute: typeof AuthenticatedServiceProvidersIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedShortLinksIndexRoute: typeof AuthenticatedShortLinksIndexRoute
  AuthenticatedSpCalendarIndexRoute: typeof AuthenticatedSpCalendarIndexRoute
  AuthenticatedUserManagementIndexRoute: typeof AuthenticatedUserManagementIndexRoute
  AuthenticatedWorkOrdersIndexRoute: typeof AuthenticatedWorkOrdersIndexRoute
  AuthenticatedFilesSTokenRoute: typeof AuthenticatedFilesSTokenRoute
  AuthenticatedProcurementPricingPricingRequestIdRoute: typeof AuthenticatedProcurementPricingPricingRequestIdRoute
  AuthenticatedClientsTeamAssignmentsIndexRoute: typeof AuthenticatedClientsTeamAssignmentsIndexRoute
  AuthenticatedMobileChatIndexRoute: typeof AuthenticatedMobileChatIndexRoute
  AuthenticatedMobileScheduleIndexRoute: typeof AuthenticatedMobileScheduleIndexRoute
  AuthenticatedMobileWorkOrderIndexRoute: typeof AuthenticatedMobileWorkOrderIndexRoute
  AuthenticatedProcurementPricingIndexRoute: typeof AuthenticatedProcurementPricingIndexRoute
  AuthenticatedServiceProvidersReactiveHireRequestsIndexRoute: typeof AuthenticatedServiceProvidersReactiveHireRequestsIndexRoute
  AuthenticatedServiceProvidersW9RequestsIndexRoute: typeof AuthenticatedServiceProvidersW9RequestsIndexRoute
  AuthenticatedWorkOrdersWorkOrderIdIndexRoute: typeof AuthenticatedWorkOrdersWorkOrderIdIndexRoute
  AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRoute: typeof AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRoute
  AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRoute: typeof AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRoute
  AuthenticatedMobileWorkOrderAcceptIdIndexRoute: typeof AuthenticatedMobileWorkOrderAcceptIdIndexRoute
  AuthenticatedMobileWorkOrderCheckInIdIndexRoute: typeof AuthenticatedMobileWorkOrderCheckInIdIndexRoute
  AuthenticatedMobileWorkOrderDetailsIdIndexRoute: typeof AuthenticatedMobileWorkOrderDetailsIdIndexRoute
  AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRoute: typeof AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRoute
  AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRoute: typeof AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAccountsPayableManageRoute:
    AuthenticatedAccountsPayableManageRoute,
  AuthenticatedAccountsPayableSpPaymentMethodsRoute:
    AuthenticatedAccountsPayableSpPaymentMethodsRoute,
  AuthenticatedClientsIdRoute: AuthenticatedClientsIdRoute,
  AuthenticatedCloseOutWorkOrderIdRoute: AuthenticatedCloseOutWorkOrderIdRoute,
  AuthenticatedEntitiesEntityIdRoute: AuthenticatedEntitiesEntityIdRoute,
  AuthenticatedLiveMapAlertsRoute: AuthenticatedLiveMapAlertsRoute,
  AuthenticatedLocationsIdRoute: AuthenticatedLocationsIdRoute,
  AuthenticatedProcurementRequestIdRoute:
    AuthenticatedProcurementRequestIdRoute,
  AuthenticatedProcurementAccountsRoute: AuthenticatedProcurementAccountsRoute,
  AuthenticatedProcurementCalendarRoute: AuthenticatedProcurementCalendarRoute,
  AuthenticatedProcurementNewRoute: AuthenticatedProcurementNewRoute,
  AuthenticatedProcurementOverviewRoute: AuthenticatedProcurementOverviewRoute,
  AuthenticatedProcurementReturnsRoute: AuthenticatedProcurementReturnsRoute,
  AuthenticatedProcurementStorageUnitsRoute:
    AuthenticatedProcurementStorageUnitsRoute,
  AuthenticatedProposalsManageRoute: AuthenticatedProposalsManageRoute,
  AuthenticatedRolesPermissionsRoleIdRoute:
    AuthenticatedRolesPermissionsRoleIdRoute,
  AuthenticatedRolesPermissionsCompareRoute:
    AuthenticatedRolesPermissionsCompareRoute,
  AuthenticatedServiceProvidersIdRoute: AuthenticatedServiceProvidersIdRoute,
  AuthenticatedShortLinksLinkIdRoute: AuthenticatedShortLinksLinkIdRoute,
  AuthenticatedUserManagementUserIdRoute:
    AuthenticatedUserManagementUserIdRoute,
  AuthenticatedAccountsPayableIndexRoute:
    AuthenticatedAccountsPayableIndexRoute,
  AuthenticatedAccountsReceivableIndexRoute:
    AuthenticatedAccountsReceivableIndexRoute,
  AuthenticatedAllFilesIndexRoute: AuthenticatedAllFilesIndexRoute,
  AuthenticatedAssetsIndexRoute: AuthenticatedAssetsIndexRoute,
  AuthenticatedChatIndexRoute: AuthenticatedChatIndexRoute,
  AuthenticatedCheckInOutIndexRoute: AuthenticatedCheckInOutIndexRoute,
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
  AuthenticatedCloseOutIndexRoute: AuthenticatedCloseOutIndexRoute,
  AuthenticatedDispatchQueueIndexRoute: AuthenticatedDispatchQueueIndexRoute,
  AuthenticatedEmailAiIndexRoute: AuthenticatedEmailAiIndexRoute,
  AuthenticatedEntitiesIndexRoute: AuthenticatedEntitiesIndexRoute,
  AuthenticatedFilesIndexRoute: AuthenticatedFilesIndexRoute,
  AuthenticatedFmIntegrationsIndexRoute: AuthenticatedFmIntegrationsIndexRoute,
  AuthenticatedFormBuilderIndexRoute: AuthenticatedFormBuilderIndexRoute,
  AuthenticatedFormManagerIndexRoute: AuthenticatedFormManagerIndexRoute,
  AuthenticatedLiveMapIndexRoute: AuthenticatedLiveMapIndexRoute,
  AuthenticatedLocationsIndexRoute: AuthenticatedLocationsIndexRoute,
  AuthenticatedMyTasksIndexRoute: AuthenticatedMyTasksIndexRoute,
  AuthenticatedProcurementIndexRoute: AuthenticatedProcurementIndexRoute,
  AuthenticatedProposalsIndexRoute: AuthenticatedProposalsIndexRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedRolesPermissionsIndexRoute:
    AuthenticatedRolesPermissionsIndexRoute,
  AuthenticatedServiceProvidersIndexRoute:
    AuthenticatedServiceProvidersIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedShortLinksIndexRoute: AuthenticatedShortLinksIndexRoute,
  AuthenticatedSpCalendarIndexRoute: AuthenticatedSpCalendarIndexRoute,
  AuthenticatedUserManagementIndexRoute: AuthenticatedUserManagementIndexRoute,
  AuthenticatedWorkOrdersIndexRoute: AuthenticatedWorkOrdersIndexRoute,
  AuthenticatedFilesSTokenRoute: AuthenticatedFilesSTokenRoute,
  AuthenticatedProcurementPricingPricingRequestIdRoute:
    AuthenticatedProcurementPricingPricingRequestIdRoute,
  AuthenticatedClientsTeamAssignmentsIndexRoute:
    AuthenticatedClientsTeamAssignmentsIndexRoute,
  AuthenticatedMobileChatIndexRoute: AuthenticatedMobileChatIndexRoute,
  AuthenticatedMobileScheduleIndexRoute: AuthenticatedMobileScheduleIndexRoute,
  AuthenticatedMobileWorkOrderIndexRoute:
    AuthenticatedMobileWorkOrderIndexRoute,
  AuthenticatedProcurementPricingIndexRoute:
    AuthenticatedProcurementPricingIndexRoute,
  AuthenticatedServiceProvidersReactiveHireRequestsIndexRoute:
    AuthenticatedServiceProvidersReactiveHireRequestsIndexRoute,
  AuthenticatedServiceProvidersW9RequestsIndexRoute:
    AuthenticatedServiceProvidersW9RequestsIndexRoute,
  AuthenticatedWorkOrdersWorkOrderIdIndexRoute:
    AuthenticatedWorkOrdersWorkOrderIdIndexRoute,
  AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRoute:
    AuthenticatedWorkOrdersWorkOrderIdVisitIdResolvedFormsRoute,
  AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRoute:
    AuthenticatedWorkOrdersWorkOrderIdVisitIdIndexRoute,
  AuthenticatedMobileWorkOrderAcceptIdIndexRoute:
    AuthenticatedMobileWorkOrderAcceptIdIndexRoute,
  AuthenticatedMobileWorkOrderCheckInIdIndexRoute:
    AuthenticatedMobileWorkOrderCheckInIdIndexRoute,
  AuthenticatedMobileWorkOrderDetailsIdIndexRoute:
    AuthenticatedMobileWorkOrderDetailsIdIndexRoute,
  AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRoute:
    AuthenticatedMobileWorkOrderJobsiteAssessmentIdIndexRoute,
  AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRoute:
    AuthenticatedWorkOrdersWorkOrderIdProposalCreateIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedSsoCallbackRoute: typeof UnauthenticatedSsoCallbackRoute
  UnauthenticatedForgotPasswordIndexRoute: typeof UnauthenticatedForgotPasswordIndexRoute
  UnauthenticatedLoginIndexRoute: typeof UnauthenticatedLoginIndexRoute
  UnauthenticatedResetLinkExpiryIndexRoute: typeof UnauthenticatedResetLinkExpiryIndexRoute
  UnauthenticatedResetPasswordIndexRoute: typeof UnauthenticatedResetPasswordIndexRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedSsoCallbackRoute: UnauthenticatedSsoCallbackRoute,
  UnauthenticatedForgotPasswordIndexRoute:
    UnauthenticatedForgotPasswordIndexRoute,
  UnauthenticatedLoginIndexRoute: UnauthenticatedLoginIndexRoute,
  UnauthenticatedResetLinkExpiryIndexRoute:
    UnauthenticatedResetLinkExpiryIndexRoute,
  UnauthenticatedResetPasswordIndexRoute:
    UnauthenticatedResetPasswordIndexRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

interface FormBuilderFormBuilderLayoutRouteChildren {
  FormBuilderFormBuilderLayoutAssignmentsCategoryRoute: typeof FormBuilderFormBuilderLayoutAssignmentsCategoryRoute
  FormBuilderFormBuilderLayoutAssignmentsIndexRoute: typeof FormBuilderFormBuilderLayoutAssignmentsIndexRoute
  FormBuilderFormBuilderLayoutTemplatesIndexRoute: typeof FormBuilderFormBuilderLayoutTemplatesIndexRoute
  FormBuilderFormBuilderLayoutTemplatesIdEditRoute: typeof FormBuilderFormBuilderLayoutTemplatesIdEditRoute
}

const FormBuilderFormBuilderLayoutRouteChildren: FormBuilderFormBuilderLayoutRouteChildren =
  {
    FormBuilderFormBuilderLayoutAssignmentsCategoryRoute:
      FormBuilderFormBuilderLayoutAssignmentsCategoryRoute,
    FormBuilderFormBuilderLayoutAssignmentsIndexRoute:
      FormBuilderFormBuilderLayoutAssignmentsIndexRoute,
    FormBuilderFormBuilderLayoutTemplatesIndexRoute:
      FormBuilderFormBuilderLayoutTemplatesIndexRoute,
    FormBuilderFormBuilderLayoutTemplatesIdEditRoute:
      FormBuilderFormBuilderLayoutTemplatesIdEditRoute,
  }

const FormBuilderFormBuilderLayoutRouteWithChildren =
  FormBuilderFormBuilderLayoutRoute._addFileChildren(
    FormBuilderFormBuilderLayoutRouteChildren,
  )

interface ClientsAddNewClientAddNewClientLayoutRouteChildren {
  ClientsAddNewClientAddNewClientLayoutStepIdIndexRoute: typeof ClientsAddNewClientAddNewClientLayoutStepIdIndexRoute
}

const ClientsAddNewClientAddNewClientLayoutRouteChildren: ClientsAddNewClientAddNewClientLayoutRouteChildren =
  {
    ClientsAddNewClientAddNewClientLayoutStepIdIndexRoute:
      ClientsAddNewClientAddNewClientLayoutStepIdIndexRoute,
  }

const ClientsAddNewClientAddNewClientLayoutRouteWithChildren =
  ClientsAddNewClientAddNewClientLayoutRoute._addFileChildren(
    ClientsAddNewClientAddNewClientLayoutRouteChildren,
  )

interface ServiceProvidersOnboardingOnboardingLayoutRouteChildren {
  ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRoute: typeof ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRoute
  ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRoute: typeof ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRoute
}

const ServiceProvidersOnboardingOnboardingLayoutRouteChildren: ServiceProvidersOnboardingOnboardingLayoutRouteChildren =
  {
    ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRoute:
      ServiceProvidersOnboardingOnboardingLayoutCompleteOnboardingIndexRoute,
    ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRoute:
      ServiceProvidersOnboardingOnboardingLayoutProviderTypeStepIdIndexRoute,
  }

const ServiceProvidersOnboardingOnboardingLayoutRouteWithChildren =
  ServiceProvidersOnboardingOnboardingLayoutRoute._addFileChildren(
    ServiceProvidersOnboardingOnboardingLayoutRouteChildren,
  )

interface SpInviteReviewReviewLayoutRouteChildren {
  SpInviteReviewReviewLayoutCompleteSubmissionIndexRoute: typeof SpInviteReviewReviewLayoutCompleteSubmissionIndexRoute
  SpInviteReviewReviewLayoutProviderTypeStepIdIndexRoute: typeof SpInviteReviewReviewLayoutProviderTypeStepIdIndexRoute
}

const SpInviteReviewReviewLayoutRouteChildren: SpInviteReviewReviewLayoutRouteChildren =
  {
    SpInviteReviewReviewLayoutCompleteSubmissionIndexRoute:
      SpInviteReviewReviewLayoutCompleteSubmissionIndexRoute,
    SpInviteReviewReviewLayoutProviderTypeStepIdIndexRoute:
      SpInviteReviewReviewLayoutProviderTypeStepIdIndexRoute,
  }

const SpInviteReviewReviewLayoutRouteWithChildren =
  SpInviteReviewReviewLayoutRoute._addFileChildren(
    SpInviteReviewReviewLayoutRouteChildren,
  )

interface ServiceProvidersIdAlignmentAlignmentLayoutRouteChildren {
  ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRoute
  ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRoute
  ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRoute: typeof ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRoute
}

const ServiceProvidersIdAlignmentAlignmentLayoutRouteChildren: ServiceProvidersIdAlignmentAlignmentLayoutRouteChildren =
  {
    ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRoute:
      ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeIndexRoute,
    ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRoute:
      ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeStepIdIndexRoute,
    ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRoute:
      ServiceProvidersIdAlignmentAlignmentLayoutProviderTypeSummaryIndexRoute,
  }

const ServiceProvidersIdAlignmentAlignmentLayoutRouteWithChildren =
  ServiceProvidersIdAlignmentAlignmentLayoutRoute._addFileChildren(
    ServiceProvidersIdAlignmentAlignmentLayoutRouteChildren,
  )

interface WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteChildren {
  WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRoute: typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRoute
  WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRoute: typeof WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRoute
}

const WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteChildren: WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteChildren =
  {
    WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRoute:
      WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRequestProviderRoute,
    WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRoute:
      WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutIndexRoute,
  }

const WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteWithChildren =
  WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRoute._addFileChildren(
    WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
  FormBuilderFormBuilderLayoutRoute:
    FormBuilderFormBuilderLayoutRouteWithChildren,
  SpHomeIndexRoute: SpHomeIndexRoute,
  SpInviteIndexRoute: SpInviteIndexRoute,
  ClientsIdEditClientCoverageRoute: ClientsIdEditClientCoverageRoute,
  ClientsAddNewClientAddNewClientLayoutRoute:
    ClientsAddNewClientAddNewClientLayoutRouteWithChildren,
  EntitiesCreateEntityAddUsersRoute: EntitiesCreateEntityAddUsersRoute,
  EntitiesCreateEntitySuccessRoute: EntitiesCreateEntitySuccessRoute,
  ServiceProvidersOnboardingOnboardingLayoutRoute:
    ServiceProvidersOnboardingOnboardingLayoutRouteWithChildren,
  SpInviteReviewReviewLayoutRoute: SpInviteReviewReviewLayoutRouteWithChildren,
  UserManagementAddUserUserIdRoute: UserManagementAddUserUserIdRoute,
  EntitiesCreateEntityIndexRoute: EntitiesCreateEntityIndexRoute,
  FormBuilderEditorIndexRoute: FormBuilderEditorIndexRoute,
  RolesPermissionsAssignPermissionsIndexRoute:
    RolesPermissionsAssignPermissionsIndexRoute,
  SpPaymentTokenIndexRoute: SpPaymentTokenIndexRoute,
  SpVisitFormTokenIndexRoute: SpVisitFormTokenIndexRoute,
  SpW9TokenIndexRoute: SpW9TokenIndexRoute,
  UserManagementAddUserIndexRoute: UserManagementAddUserIndexRoute,
  WorkOrdersAddWorkOrderIndexRoute: WorkOrdersAddWorkOrderIndexRoute,
  ServiceProvidersIdAlignmentAlignmentLayoutRoute:
    ServiceProvidersIdAlignmentAlignmentLayoutRouteWithChildren,
  SpInviteReviewAlignmentScheduledIndexRoute:
    SpInviteReviewAlignmentScheduledIndexRoute,
  WorkOrdersWorkOrderIdAcceptWorkOrderIndexRoute:
    WorkOrdersWorkOrderIdAcceptWorkOrderIndexRoute,
  WorkOrdersWorkOrderIdAddVisitIndexRoute:
    WorkOrdersWorkOrderIdAddVisitIndexRoute,
  WorkOrdersWorkOrderIdCheckInIndexRoute:
    WorkOrdersWorkOrderIdCheckInIndexRoute,
  WorkOrdersWorkOrderIdEditWorkOrderIndexRoute:
    WorkOrdersWorkOrderIdEditWorkOrderIndexRoute,
  WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRoute:
    WorkOrdersWorkOrderIdVisitIdAssignServiceProviderAssignServiceProviderLayoutRouteWithChildren,
  ClientsIdEditRatesLaborFeeIndexRoute: ClientsIdEditRatesLaborFeeIndexRoute,
  WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRoute:
    WorkOrdersWorkOrderIdVisitIdAssessmentDetailsIndexRoute,
  WorkOrdersWorkOrderIdVisitIdEditIndexRoute:
    WorkOrdersWorkOrderIdVisitIdEditIndexRoute,
  WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRoute:
    WorkOrdersWorkOrderIdVisitIdFormPreviewIndexRoute,
  WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRoute:
    WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderAcceptedIndexRoute,
  WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRoute:
    WorkOrdersWorkOrderIdAcceptWorkOrderWorkOrderFilledIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
